msgid ""
msgstr ""
"POT-Creation-Date: 2024-08-04 21:58+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: lt\n"
"Project-Id-Version: phanpy\n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: 2024-11-19 14:44\n"
"Last-Translator: \n"
"Language-Team: Lithuanian\n"
"Plural-Forms: nplurals=4; plural=(n%10==1 && (n%100>19 || n%100<11) ? 0 : (n%10>=2 && n%10<=9) && (n%100>19 || n%100<11) ? 1 : n%1!=0 ? 2: 3);\n"
"X-Crowdin-Project: phanpy\n"
"X-Crowdin-Project-ID: 703337\n"
"X-Crowdin-Language: lt\n"
"X-Crowdin-File: /main/src/locales/en.po\n"
"X-Crowdin-File-ID: 18\n"

#: src/components/account-block.jsx:135
msgid "Locked"
msgstr "Užrakinta"

#: src/components/account-block.jsx:141
msgid "Posts: {0}"
msgstr "Įrašai: {0}"

#: src/components/account-block.jsx:146
msgid "Last posted: {0}"
msgstr "Paskutinį kartą paskelbta: {0}"

#: src/components/account-block.jsx:161
#: src/components/account-info.jsx:636
msgid "Automated"
msgstr "Automatizuotas"

#: src/components/account-block.jsx:168
#: src/components/account-info.jsx:641
#: src/components/status.jsx:498
msgid "Group"
msgstr "Grupuoti"

#: src/components/account-block.jsx:178
msgid "Mutual"
msgstr "Bendri"

#: src/components/account-block.jsx:182
#: src/components/account-info.jsx:1682
msgid "Requested"
msgstr "Paprašyta"

#: src/components/account-block.jsx:186
#: src/components/account-info.jsx:1673
msgid "Following"
msgstr "Sekama"

#: src/components/account-block.jsx:190
#: src/components/account-info.jsx:1064
msgid "Follows you"
msgstr "Seka tave"

#: src/components/account-block.jsx:198
msgid "{followersCount, plural, one {# follower} other {# followers}}"
msgstr "{followersCount, plural, one {# sekėjas} few {# sekėjai} many {# sekėjo} other {# sekėjų}}"

#: src/components/account-block.jsx:207
#: src/components/account-info.jsx:682
msgid "Verified"
msgstr "Patvirtinta"

#: src/components/account-block.jsx:222
#: src/components/account-info.jsx:782
msgid "Joined <0>{0}</0>"
msgstr "Prisijungė <0>{0}</0>"

#: src/components/account-info.jsx:58
msgid "Forever"
msgstr "Visam laikui"

#: src/components/account-info.jsx:379
msgid "Unable to load account."
msgstr "Nepavyksta įkelti paskyros."

#: src/components/account-info.jsx:387
msgid "Go to account page"
msgstr "Eiti į paskyros puslapį"

#: src/components/account-info.jsx:415
#: src/components/account-info.jsx:704
#: src/components/account-info.jsx:734
msgid "Followers"
msgstr "Sekėjai"

#. js-lingui-explicit-id
#: src/components/account-info.jsx:418
#: src/components/account-info.jsx:744
#: src/components/account-info.jsx:761
msgid "following.stats"
msgstr "Sekimai"

#: src/components/account-info.jsx:421
#: src/components/account-info.jsx:778
#: src/pages/account-statuses.jsx:484
#: src/pages/search.jsx:323
#: src/pages/search.jsx:470
msgid "Posts"
msgstr "Įrašai"

#: src/components/account-info.jsx:429
#: src/components/account-info.jsx:1120
#: src/components/compose.jsx:2488
#: src/components/media-alt-modal.jsx:45
#: src/components/media-modal.jsx:357
#: src/components/status.jsx:1721
#: src/components/status.jsx:1738
#: src/components/status.jsx:1862
#: src/components/status.jsx:2474
#: src/components/status.jsx:2477
#: src/pages/account-statuses.jsx:528
#: src/pages/accounts.jsx:109
#: src/pages/hashtag.jsx:199
#: src/pages/list.jsx:157
#: src/pages/public.jsx:114
#: src/pages/status.jsx:1212
#: src/pages/trending.jsx:471
msgid "More"
msgstr "Daugiau"

#: src/components/account-info.jsx:441
msgid "<0>{displayName}</0> has indicated that their new account is now:"
msgstr "<0>{displayName}</0> nurodė, kad jų naujoji paskyra dabar yra:"

#: src/components/account-info.jsx:586
#: src/components/account-info.jsx:1278
msgid "Handle copied"
msgstr "Nukopijuotas socialinis medijos vardas"

#: src/components/account-info.jsx:589
#: src/components/account-info.jsx:1281
msgid "Unable to copy handle"
msgstr "Nepavyksta nukopijuoti socialinės medijos vardo."

#: src/components/account-info.jsx:595
#: src/components/account-info.jsx:1287
msgid "Copy handle"
msgstr "Kopijuoti socialinės medijos vardą"

#: src/components/account-info.jsx:601
msgid "Go to original profile page"
msgstr "Eiti į originalų profilio puslapį"

#: src/components/account-info.jsx:608
msgid "View profile image"
msgstr "Peržiūrėti profilio vaizdą"

#: src/components/account-info.jsx:614
msgid "View profile header"
msgstr "Peržiūrėti profilio antraštę"

#: src/components/account-info.jsx:631
msgid "In Memoriam"
msgstr "Atminimui"

#: src/components/account-info.jsx:711
#: src/components/account-info.jsx:752
msgid "This user has chosen to not make this information available."
msgstr "Šis naudotojas pasirinko nepadaryti šią informaciją prieinamą."

#: src/components/account-info.jsx:807
msgid "{0} original posts, {1} replies, {2} boosts"
msgstr "{0} originalūs įrašai, {1} atsakymai, {2} pasidalinimai"

#: src/components/account-info.jsx:823
msgid "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"
msgstr "{0, plural, one {{1, plural, one {Paskutinis {0} įrašas per pastarąją {1} dieną} few {Paskutinis 1 įrašas per pastarąsias {2} dienas} many {Paskutinis 1 įrašas per pastarąsias {2} dienos} other {Paskutinis 1 įrašas per pastarąsias {2} dienų}}} few {{3, plural, one {Paskutiniai {4} įrašai per pastarąją 1 dieną} few {Paskutiniai {5} įrašai per pastarąsias {6} dienas} many {Paskutinio {5} įrašo per pastaruosius {6} dienos} other {Paskutinių {5} įrašų per pastarąsias {6} dienų}}} many {{3, plural, one {Paskutiniai {4} įrašai per pastarąją 1 dieną} few {Paskutiniai {5} įrašai per pastarąsias {6} dienas} many {Paskutinio {5} įrašo per pastaruosius {6} dienos} other {Paskutinių {5} įrašų per pastarąsias {6} dienų}}} other {{3, plural, one {Paskutiniai {4} įrašai per pastarąją 1 dieną} few {Paskutiniai {5} įrašai per pastarąsias {6} dienas} many {Paskutinio {5} įrašo per pastaruosius {6} dienos} other {Paskutinių {5} įrašų per pastarąsias {6} dienų}}}}"

#: src/components/account-info.jsx:836
msgid "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"
msgstr "{0, plural, one {{1} paskutinis įrašas per pastaruosius metus} few {{1} paskutiniai įrašai per pastaruosius metus} many {{1} paskutinio įrašo per pastaruosius metus} other {{1} paskutinių įrašų per pastaruosius metus}}"

#: src/components/account-info.jsx:860
#: src/pages/catchup.jsx:70
msgid "Original"
msgstr "Originalūs"

#: src/components/account-info.jsx:864
#: src/components/status.jsx:2252
#: src/pages/catchup.jsx:71
#: src/pages/catchup.jsx:1445
#: src/pages/catchup.jsx:2056
#: src/pages/status.jsx:935
#: src/pages/status.jsx:1557
msgid "Replies"
msgstr "Atsakymai"

#: src/components/account-info.jsx:868
#: src/pages/catchup.jsx:72
#: src/pages/catchup.jsx:1447
#: src/pages/catchup.jsx:2068
#: src/pages/settings.jsx:1153
msgid "Boosts"
msgstr "Pasidalinimai"

#: src/components/account-info.jsx:874
msgid "Post stats unavailable."
msgstr "Įrašo statistika nepasiekiama."

#: src/components/account-info.jsx:905
msgid "View post stats"
msgstr "Peržiūrėti įrašų statistiką"

#: src/components/account-info.jsx:1068
msgid "Last post: <0>{0}</0>"
msgstr "Paskutinis įrašas: <0>{0}</0>"

#: src/components/account-info.jsx:1082
msgid "Muted"
msgstr "Nutildyta"

#: src/components/account-info.jsx:1087
msgid "Blocked"
msgstr "Užblokuota"

#: src/components/account-info.jsx:1096
msgid "Private note"
msgstr "Privati pastaba"

#: src/components/account-info.jsx:1153
msgid "Mention <0>@{username}</0>"
msgstr "Paminėti <0>@{username}</0>"

#: src/components/account-info.jsx:1165
msgid "Translate bio"
msgstr "Versti biografiją"

#: src/components/account-info.jsx:1176
msgid "Edit private note"
msgstr "Redaguoti privačią pastabą"

#: src/components/account-info.jsx:1176
msgid "Add private note"
msgstr "Pridėti privačią pastabą"

#: src/components/account-info.jsx:1196
msgid "Notifications enabled for @{username}'s posts."
msgstr "Įjungti pranešimai apie @{username} įrašus."

#: src/components/account-info.jsx:1197
msgid "Notifications disabled for @{username}'s posts."
msgstr "Išjungti pranešimai apie @{username} įrašus."

#: src/components/account-info.jsx:1209
msgid "Disable notifications"
msgstr "Išjungti pranešimus"

#: src/components/account-info.jsx:1210
msgid "Enable notifications"
msgstr "Įjungti pranešimus"

#: src/components/account-info.jsx:1227
msgid "Boosts from @{username} enabled."
msgstr "Įjungti pasidalinimai iš @{username}."

#: src/components/account-info.jsx:1228
msgid "Boosts from @{username} disabled."
msgstr "Išjungti pasidalinimai iš @{username}."

#: src/components/account-info.jsx:1239
msgid "Disable boosts"
msgstr "Išjungti pasidalinimus"

#: src/components/account-info.jsx:1239
msgid "Enable boosts"
msgstr "Įjungti pasidalinimus"

#: src/components/account-info.jsx:1255
#: src/components/account-info.jsx:1265
#: src/components/account-info.jsx:1866
msgid "Add/Remove from Lists"
msgstr "Pridėti / šalinti iš sąrašų"

#: src/components/account-info.jsx:1304
#: src/components/status.jsx:1161
msgid "Link copied"
msgstr "Nukopijuota nuorada"

#: src/components/account-info.jsx:1307
#: src/components/status.jsx:1164
msgid "Unable to copy link"
msgstr "Nepavyksta atidaryti nuorodos."

#: src/components/account-info.jsx:1313
#: src/components/shortcuts-settings.jsx:1059
#: src/components/status.jsx:1170
#: src/components/status.jsx:3251
msgid "Copy"
msgstr "Kopijuoti"

#: src/components/account-info.jsx:1328
#: src/components/shortcuts-settings.jsx:1077
#: src/components/status.jsx:1186
msgid "Sharing doesn't seem to work."
msgstr "Atrodo, kad bendrinimas neveikia."

#: src/components/account-info.jsx:1334
#: src/components/status.jsx:1192
msgid "Share…"
msgstr "Bendrinti…"

#: src/components/account-info.jsx:1354
msgid "Unmuted @{username}"
msgstr "Atšauktas @{username} nutildymas"

#: src/components/account-info.jsx:1366
msgid "Unmute <0>@{username}</0>"
msgstr "Atšaukti nutildymą <0>@{username}></0>"

#: src/components/account-info.jsx:1382
msgid "Mute <0>@{username}</0>…"
msgstr "Nutildyti <0>@{username}</0>…"

#: src/components/account-info.jsx:1414
msgid "Muted @{username} for {0}"
msgstr "Nutildytas @{username} dėl {0}"

#: src/components/account-info.jsx:1426
msgid "Unable to mute @{username}"
msgstr "Nepavyksta nutildyti @{username}."

#: src/components/account-info.jsx:1447
msgid "Remove <0>@{username}</0> from followers?"
msgstr "Pašalinti <0>@{username}</0> iš sekėjų?"

#: src/components/account-info.jsx:1467
msgid "@{username} removed from followers"
msgstr "@{username} pašalintas iš sekėjų"

#: src/components/account-info.jsx:1479
msgid "Remove follower…"
msgstr "Šalinti sekėją…"

#: src/components/account-info.jsx:1490
msgid "Block <0>@{username}</0>?"
msgstr "Bluokuoti <0>@{username}</0>?"

#: src/components/account-info.jsx:1514
msgid "Unblocked @{username}"
msgstr "Atblokuotas @{username}"

#: src/components/account-info.jsx:1522
msgid "Blocked @{username}"
msgstr "Užblokuotas @{username}"

#: src/components/account-info.jsx:1530
msgid "Unable to unblock @{username}"
msgstr "Nepavyksta atblokuoti @{username}."

#: src/components/account-info.jsx:1532
msgid "Unable to block @{username}"
msgstr "Nepavyksta užblokuoti @{username}."

#: src/components/account-info.jsx:1542
msgid "Unblock <0>@{username}</0>"
msgstr "Atblokuoti <0>@{username}</0>"

#: src/components/account-info.jsx:1551
msgid "Block <0>@{username}</0>…"
msgstr "Bluokuoti <0>@{username}</0>…"

#: src/components/account-info.jsx:1568
msgid "Report <0>@{username}</0>…"
msgstr "Pranešti apie <0>@{username}</0>…"

#: src/components/account-info.jsx:1588
#: src/components/account-info.jsx:2099
msgid "Edit profile"
msgstr "Redaguoti profilį"

#: src/components/account-info.jsx:1624
msgid "Withdraw follow request?"
msgstr "Atšaukti sekimo prašymą?"

#: src/components/account-info.jsx:1625
msgid "Unfollow @{0}?"
msgstr "Nebesekti @{0}?"

#: src/components/account-info.jsx:1676
msgid "Unfollow…"
msgstr "Nebesekti…"

#: src/components/account-info.jsx:1685
msgid "Withdraw…"
msgstr "Atšaukti…"

#: src/components/account-info.jsx:1692
#: src/components/account-info.jsx:1696
#: src/pages/hashtag.jsx:261
msgid "Follow"
msgstr "Sekti"

#: src/components/account-info.jsx:1807
#: src/components/account-info.jsx:1861
#: src/components/account-info.jsx:1994
#: src/components/account-info.jsx:2094
#: src/components/account-sheet.jsx:37
#: src/components/compose.jsx:818
#: src/components/compose.jsx:2444
#: src/components/compose.jsx:2917
#: src/components/compose.jsx:3125
#: src/components/compose.jsx:3355
#: src/components/drafts.jsx:58
#: src/components/embed-modal.jsx:12
#: src/components/generic-accounts.jsx:142
#: src/components/keyboard-shortcuts-help.jsx:39
#: src/components/list-add-edit.jsx:35
#: src/components/media-alt-modal.jsx:33
#: src/components/media-modal.jsx:321
#: src/components/notification-service.jsx:156
#: src/components/report-modal.jsx:75
#: src/components/shortcuts-settings.jsx:230
#: src/components/shortcuts-settings.jsx:583
#: src/components/shortcuts-settings.jsx:783
#: src/components/status.jsx:2976
#: src/components/status.jsx:3215
#: src/components/status.jsx:3713
#: src/pages/accounts.jsx:36
#: src/pages/catchup.jsx:1581
#: src/pages/filters.jsx:224
#: src/pages/list.jsx:274
#: src/pages/notifications.jsx:868
#: src/pages/notifications.jsx:1082
#: src/pages/settings.jsx:77
#: src/pages/status.jsx:1299
msgid "Close"
msgstr "Uždaryti"

#: src/components/account-info.jsx:1812
msgid "Translated Bio"
msgstr "Išversta biografija"

#: src/components/account-info.jsx:1906
msgid "Unable to remove from list."
msgstr "Nepavyksta pašalinti iš sąrašo."

#: src/components/account-info.jsx:1907
msgid "Unable to add to list."
msgstr "Nepavyksta pridėti prie sąrašo."

#: src/components/account-info.jsx:1926
#: src/pages/lists.jsx:104
msgid "Unable to load lists."
msgstr "Nepavyksta įkelti sąrašų."

#: src/components/account-info.jsx:1930
msgid "No lists."
msgstr "Nėra sąrašų."

#: src/components/account-info.jsx:1941
#: src/components/list-add-edit.jsx:39
#: src/pages/lists.jsx:58
msgid "New list"
msgstr "Naujas sąrašas"

#: src/components/account-info.jsx:1999
msgid "Private note about <0>@{0}</0>"
msgstr "Privati pastaba apie <0>@{0}</0>"

#: src/components/account-info.jsx:2029
msgid "Unable to update private note."
msgstr "Nepavyksta atnaujinti privačios pastabos."

#: src/components/account-info.jsx:2052
#: src/components/account-info.jsx:2222
msgid "Cancel"
msgstr "Atšaukti"

#: src/components/account-info.jsx:2057
msgid "Save & close"
msgstr "Išsaugoti ir uždaryti"

#: src/components/account-info.jsx:2150
msgid "Unable to update profile."
msgstr "Nepavyksta atnaujinti profilio."

#: src/components/account-info.jsx:2157
#: src/components/list-add-edit.jsx:104
msgid "Name"
msgstr "Pavadinimas"

#: src/components/account-info.jsx:2170
msgid "Bio"
msgstr "Biografija"

#: src/components/account-info.jsx:2183
msgid "Extra fields"
msgstr "Papildomi laukai"

#: src/components/account-info.jsx:2189
msgid "Label"
msgstr "Etiketė"

#: src/components/account-info.jsx:2192
msgid "Content"
msgstr "Turinys"

#: src/components/account-info.jsx:2225
#: src/components/list-add-edit.jsx:149
#: src/components/shortcuts-settings.jsx:715
#: src/pages/filters.jsx:554
#: src/pages/notifications.jsx:934
msgid "Save"
msgstr "Išsaugoti"

#: src/components/account-info.jsx:2279
msgid "username"
msgstr "naudotojo vardas"

#: src/components/account-info.jsx:2283
msgid "server domain name"
msgstr "serverio domeno vardas"

#: src/components/background-service.jsx:149
msgid "Cloak mode disabled"
msgstr "Išjungtas slėpimo režimas"

#: src/components/background-service.jsx:149
msgid "Cloak mode enabled"
msgstr "Įjungtas slėpimo režimas"

#: src/components/columns.jsx:26
#: src/components/nav-menu.jsx:175
#: src/components/shortcuts-settings.jsx:139
#: src/components/timeline.jsx:437
#: src/pages/catchup.jsx:876
#: src/pages/filters.jsx:89
#: src/pages/followed-hashtags.jsx:40
#: src/pages/home.jsx:53
#: src/pages/notifications.jsx:520
msgid "Home"
msgstr "Pagrindinis"

#: src/components/compose-button.jsx:49
#: src/compose.jsx:37
msgid "Compose"
msgstr "Sukurti"

#: src/components/compose.jsx:394
msgid "You have unsaved changes. Discard this post?"
msgstr "Turite neišsaugotų pakeitimų. Atmesti šią įrašą?"

#: src/components/compose.jsx:622
msgid "{0, plural, one {File {1} is not supported.} other {Files {2} are not supported.}}"
msgstr "{0, plural, one {{1} failas nepalaikomas.} few {{2} failai nepalaikomi.} many {{2} failo nepalaikoma.} other {{2} failų nepalaikoma.}}"

#: src/components/compose.jsx:632
#: src/components/compose.jsx:650
#: src/components/compose.jsx:1361
#: src/components/compose.jsx:1623
msgid "{maxMediaAttachments, plural, one {You can only attach up to 1 file.} other {You can only attach up to # files.}}"
msgstr "{maxMediaAttachments, plural, one {Galite pridėti tik iki # failo.} few {Galite pridėti tik iki # failų.} many {Galite pridėti tik iki # failo.} other {Galite pridėti tik iki # failų.}}"

#: src/components/compose.jsx:799
msgid "Pop out"
msgstr "Išskleisti"

#: src/components/compose.jsx:806
msgid "Minimize"
msgstr "Sumažinti"

#: src/components/compose.jsx:842
msgid "Looks like you closed the parent window."
msgstr "Atrodo, kad uždarėte pirminį langą."

#: src/components/compose.jsx:849
msgid "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."
msgstr "Atrodo, kad pirminiame lange jau atidarytas sukūrimo laukas ir šiuo metu skelbiamas. Palauk, kol jis bus baigtas, ir pabandyk dar kartą vėliau."

#: src/components/compose.jsx:854
msgid "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"
msgstr "Atrodo, kad pirminiame lange jau yra atidarytas sukūrimo laukas. Suskleisčius šiame lange, bus atmesti pakeitimai, kuriuos padarėte pirminiame lange. Tęsti?"

#: src/components/compose.jsx:896
msgid "Pop in"
msgstr "Suskleisti"

#: src/components/compose.jsx:906
msgid "Replying to @{0}’s post (<0>{1}</0>)"
msgstr "Atsakant į @{0} įrašą (<0>{1}</0>)"

#: src/components/compose.jsx:916
msgid "Replying to @{0}’s post"
msgstr "Atsakant į @{0} įrašą"

#: src/components/compose.jsx:929
msgid "Editing source post"
msgstr "Redaguojamas šaltinio įrašas"

#: src/components/compose.jsx:976
msgid "Poll must have at least 2 options"
msgstr "Apklausa turi turėti bent 2 parinktis."

#: src/components/compose.jsx:980
msgid "Some poll choices are empty"
msgstr "Kai kurie apklausos pasirinkimai yra tušti."

#: src/components/compose.jsx:993
msgid "Some media have no descriptions. Continue?"
msgstr "Kai kurios medijos neturi aprašymų. Tęsti?"

#: src/components/compose.jsx:1045
msgid "Attachment #{i} failed"
msgstr "Nepavyko #{i} priedas."

#: src/components/compose.jsx:1139
#: src/components/status.jsx:2047
#: src/components/timeline.jsx:984
msgid "Content warning"
msgstr "Turinio įspėjimas"

#: src/components/compose.jsx:1155
msgid "Content warning or sensitive media"
msgstr "Turinio įspėjimas arba jautri medija"

#: src/components/compose.jsx:1191
#: src/components/status.jsx:93
#: src/pages/settings.jsx:305
msgid "Public"
msgstr "Vieša"

#: src/components/compose.jsx:1196
#: src/components/nav-menu.jsx:337
#: src/components/shortcuts-settings.jsx:165
#: src/components/status.jsx:94
msgid "Local"
msgstr "Vietinis"

#: src/components/compose.jsx:1200
#: src/components/status.jsx:95
#: src/pages/settings.jsx:308
msgid "Unlisted"
msgstr "Neįtrauktas į sąrašą"

#: src/components/compose.jsx:1203
#: src/components/status.jsx:96
#: src/pages/settings.jsx:311
msgid "Followers only"
msgstr "Tik sekėjai"

#: src/components/compose.jsx:1206
#: src/components/status.jsx:97
#: src/components/status.jsx:1925
msgid "Private mention"
msgstr "Privatus paminėjimas"

#: src/components/compose.jsx:1215
msgid "Post your reply"
msgstr "Skelbti savo atsakymą"

#: src/components/compose.jsx:1217
msgid "Edit your post"
msgstr "Redaguoti savo įrašą"

#: src/components/compose.jsx:1218
msgid "What are you doing?"
msgstr "Ką tu darai?"

#: src/components/compose.jsx:1296
msgid "Mark media as sensitive"
msgstr "Žymėti mediją kaip jautrią"

#: src/components/compose.jsx:1397
msgid "Add poll"
msgstr "Pridėti apklausą"

#: src/components/compose.jsx:1419
msgid "Add custom emoji"
msgstr "Pridėti pasirinktinį jaustuką"

#: src/components/compose.jsx:1504
#: src/components/keyboard-shortcuts-help.jsx:151
#: src/components/status.jsx:913
#: src/components/status.jsx:1701
#: src/components/status.jsx:1702
#: src/components/status.jsx:2370
msgid "Reply"
msgstr "Atsakyti"

#: src/components/compose.jsx:1506
msgid "Update"
msgstr "Atnaujinti"

#: src/components/compose.jsx:1507
msgctxt "Submit button in composer"
msgid "Post"
msgstr "Skelbti"

#: src/components/compose.jsx:1635
msgid "Downloading GIF…"
msgstr "Atsisiunčiama GIF…"

#: src/components/compose.jsx:1663
msgid "Failed to download GIF"
msgstr "Nepavyko atsisiųsti GIF."

#: src/components/compose.jsx:1775
#: src/components/compose.jsx:1852
#: src/components/nav-menu.jsx:238
msgid "More…"
msgstr "Daugiau…"

#: src/components/compose.jsx:2257
msgid "Uploaded"
msgstr "Įkelta"

#: src/components/compose.jsx:2270
msgid "Image description"
msgstr "Vaizdo aprašymas"

#: src/components/compose.jsx:2271
msgid "Video description"
msgstr "Vaizdo įrašo aprašymas"

#: src/components/compose.jsx:2272
msgid "Audio description"
msgstr "Garso įrašo aprašymas"

#: src/components/compose.jsx:2308
#: src/components/compose.jsx:2328
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."
msgstr "Per didelis failo dydis. Įkeliant gali kilti problemų. Bandyk sumažinti failo dydį nuo {0} iki {1} arba mažiau."

#: src/components/compose.jsx:2320
#: src/components/compose.jsx:2340
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {0}×{1}px to {2}×{3}px."
msgstr "Per didelis matmuo. Įkeliant gali kilti problemų. Bandyk sumažinti matmenis nuo {0}×{1} tšk. iki {2}×{3} tšk."

#: src/components/compose.jsx:2348
msgid "Frame rate too high. Uploading might encounter issues."
msgstr "Per didelis kadrų dažnis. Įkeliant gali kilti problemų."

#: src/components/compose.jsx:2408
#: src/components/compose.jsx:2658
#: src/components/shortcuts-settings.jsx:726
#: src/pages/catchup.jsx:1074
#: src/pages/filters.jsx:412
msgid "Remove"
msgstr "Šalinti"

#: src/components/compose.jsx:2425
#: src/compose.jsx:83
msgid "Error"
msgstr "Klaida"

#: src/components/compose.jsx:2450
msgid "Edit image description"
msgstr "Redaguoti vaizdo aprašymą"

#: src/components/compose.jsx:2451
msgid "Edit video description"
msgstr "Redaguoti vaizdo įrašo aprašymą"

#: src/components/compose.jsx:2452
msgid "Edit audio description"
msgstr "Redaguoti garso įrašo aprašymą"

#: src/components/compose.jsx:2497
#: src/components/compose.jsx:2546
msgid "Generating description. Please wait…"
msgstr "Generuojamas aprašymas. Palauk…"

#: src/components/compose.jsx:2517
msgid "Failed to generate description: {0}"
msgstr "Nepavyko sugeneruoti aprašymo: {0}"

#: src/components/compose.jsx:2518
msgid "Failed to generate description"
msgstr "Nepavyko sugeneruoti aprašymo."

#: src/components/compose.jsx:2530
#: src/components/compose.jsx:2536
#: src/components/compose.jsx:2582
msgid "Generate description…"
msgstr "Generuoti aprašymą…"

#: src/components/compose.jsx:2569
msgid "Failed to generate description{0}"
msgstr "Nepavyko sugeneruoti aprašymo: {0}"

#: src/components/compose.jsx:2584
msgid "({0}) <0>— experimental</0>"
msgstr "({0}) <0>– eksperimentinė</0>"

#: src/components/compose.jsx:2603
msgid "Done"
msgstr "Atlikta"

#: src/components/compose.jsx:2639
msgid "Choice {0}"
msgstr "{0} pasirinkimas"

#: src/components/compose.jsx:2686
msgid "Multiple choices"
msgstr "Keli pasirinkimai"

#: src/components/compose.jsx:2689
msgid "Duration"
msgstr "Trukmė"

#: src/components/compose.jsx:2720
msgid "Remove poll"
msgstr "Šalinti apklausą"

#: src/components/compose.jsx:2934
msgid "Search accounts"
msgstr "Ieškoti paskyrų"

#: src/components/compose.jsx:2975
#: src/components/shortcuts-settings.jsx:715
#: src/pages/list.jsx:359
msgid "Add"
msgstr "Pridėti"

#: src/components/compose.jsx:2988
#: src/components/generic-accounts.jsx:227
msgid "Error loading accounts"
msgstr "Klaida įkeliant paskyras."

#: src/components/compose.jsx:3131
msgid "Custom emojis"
msgstr "Pasirinktiniai jaustukai"

#: src/components/compose.jsx:3151
msgid "Search emoji"
msgstr "Ieškoti jaustukų"

#: src/components/compose.jsx:3182
msgid "Error loading custom emojis"
msgstr "Klaida įkeliant pasirinktinius jaustukus."

#: src/components/compose.jsx:3193
msgid "Recently used"
msgstr "Neseniai naudoti"

#: src/components/compose.jsx:3194
msgid "Others"
msgstr "Kiti"

#: src/components/compose.jsx:3232
msgid "{0} more…"
msgstr "{0} daugiau…"

#: src/components/compose.jsx:3370
msgid "Search GIFs"
msgstr "Ieškoti GIF"

#: src/components/compose.jsx:3385
msgid "Powered by GIPHY"
msgstr "Veikiama su „GIPHY“"

#: src/components/compose.jsx:3393
msgid "Type to search GIFs"
msgstr "Rašyk, kad ieškotum GIF"

#: src/components/compose.jsx:3491
#: src/components/media-modal.jsx:461
#: src/components/timeline.jsx:889
msgid "Previous"
msgstr "Ankstesnis"

#: src/components/compose.jsx:3509
#: src/components/media-modal.jsx:480
#: src/components/timeline.jsx:906
msgid "Next"
msgstr "Kitas"

#: src/components/compose.jsx:3526
msgid "Error loading GIFs"
msgstr "Klaida įkeliant GIF."

#: src/components/drafts.jsx:63
#: src/pages/settings.jsx:692
msgid "Unsent drafts"
msgstr "Neišsiųsti juodraščiai"

#: src/components/drafts.jsx:68
msgid "Looks like you have unsent drafts. Let's continue where you left off."
msgstr "Atrodo, kad turi neišsiųstų juodraščių. Tęskime nuo ten, kur baigei."

#: src/components/drafts.jsx:102
msgid "Delete this draft?"
msgstr "Ištrinti šį juodraštį?"

#: src/components/drafts.jsx:117
msgid "Error deleting draft! Please try again."
msgstr "Klaida ištrinant juodraštį. Bandyk dar kartą."

#: src/components/drafts.jsx:127
#: src/components/list-add-edit.jsx:185
#: src/components/status.jsx:1336
#: src/pages/filters.jsx:587
msgid "Delete…"
msgstr "Ištrinti…"

#: src/components/drafts.jsx:146
msgid "Error fetching reply-to status!"
msgstr "Klaida gaunant atsakymo į būseną."

#: src/components/drafts.jsx:171
msgid "Delete all drafts?"
msgstr "Ištrinti visus juodraščius?"

#: src/components/drafts.jsx:189
msgid "Error deleting drafts! Please try again."
msgstr "Klaida ištrinant juodraščius. Bandyk dar kartą."

#: src/components/drafts.jsx:201
msgid "Delete all…"
msgstr "Ištrinti visus…"

#: src/components/drafts.jsx:209
msgid "No drafts found."
msgstr "Juodraščių nerasta."

#: src/components/drafts.jsx:245
#: src/pages/catchup.jsx:1928
msgid "Poll"
msgstr "Apklausa"

#: src/components/drafts.jsx:248
#: src/pages/account-statuses.jsx:365
msgid "Media"
msgstr "Medija"

#: src/components/embed-modal.jsx:22
msgid "Open in new window"
msgstr "Atidaryti naujame lange"

#: src/components/follow-request-buttons.jsx:42
#: src/pages/notifications.jsx:918
msgid "Accept"
msgstr "Priimti"

#: src/components/follow-request-buttons.jsx:68
msgid "Reject"
msgstr "Atmesti"

#: src/components/follow-request-buttons.jsx:75
#: src/pages/notifications.jsx:1201
msgid "Accepted"
msgstr "Priimta"

#: src/components/follow-request-buttons.jsx:79
msgid "Rejected"
msgstr "Atmesta"

#: src/components/generic-accounts.jsx:24
msgid "Nothing to show"
msgstr "Nėra ką rodyti."

#: src/components/generic-accounts.jsx:145
#: src/components/notification.jsx:438
#: src/pages/accounts.jsx:41
#: src/pages/search.jsx:313
#: src/pages/search.jsx:346
msgid "Accounts"
msgstr "Paskyros"

#: src/components/generic-accounts.jsx:205
#: src/components/timeline.jsx:519
#: src/pages/list.jsx:293
#: src/pages/notifications.jsx:848
#: src/pages/search.jsx:540
#: src/pages/status.jsx:1332
msgid "Show more…"
msgstr "Rodyti daugiau…"

#: src/components/generic-accounts.jsx:210
#: src/components/timeline.jsx:524
#: src/pages/search.jsx:545
msgid "The end."
msgstr "Pabaiga."

#: src/components/keyboard-shortcuts-help.jsx:43
#: src/components/nav-menu.jsx:356
#: src/pages/catchup.jsx:1619
msgid "Keyboard shortcuts"
msgstr "Spartieji klaviatūros klavišai"

#: src/components/keyboard-shortcuts-help.jsx:51
msgid "Keyboard shortcuts help"
msgstr "Spartieji klaviatūros klavišos žinynas"

#: src/components/keyboard-shortcuts-help.jsx:55
#: src/pages/catchup.jsx:1644
msgid "Next post"
msgstr "Sekantis įrašas"

#: src/components/keyboard-shortcuts-help.jsx:59
#: src/pages/catchup.jsx:1652
msgid "Previous post"
msgstr "Ankstesnis įrašas"

#: src/components/keyboard-shortcuts-help.jsx:63
msgid "Skip carousel to next post"
msgstr "Praleisti karuselę į kitą įrašą"

#: src/components/keyboard-shortcuts-help.jsx:65
msgid "<0>Shift</0> + <1>j</1>"
msgstr "<0>Lyg2 (Shift)</0> + <1>j</1>"

#: src/components/keyboard-shortcuts-help.jsx:71
msgid "Skip carousel to previous post"
msgstr "Praleisti karuselę į ankstesnį įrašą"

#: src/components/keyboard-shortcuts-help.jsx:73
msgid "<0>Shift</0> + <1>k</1>"
msgstr "<0>Lyg2 (Shift)</0> + <1>k</1>"

#: src/components/keyboard-shortcuts-help.jsx:79
msgid "Load new posts"
msgstr "Įkelti naujų įrašų"

#: src/components/keyboard-shortcuts-help.jsx:83
#: src/pages/catchup.jsx:1676
msgid "Open post details"
msgstr "Atidaryti įrašo informaciją"

#: src/components/keyboard-shortcuts-help.jsx:85
msgid "<0>Enter</0> or <1>o</1>"
msgstr "<0>Įvesti (Enter)</0> arba <1>o</1>"

#: src/components/keyboard-shortcuts-help.jsx:92
msgid "Expand content warning or<0/>toggle expanded/collapsed thread"
msgstr "Išskleisti turinio įspėjimą arba<0/>perjungti išskleistą / suskleistą giją"

#: src/components/keyboard-shortcuts-help.jsx:101
msgid "Close post or dialogs"
msgstr "Uždaryti įrašą arba dialogo langus"

#: src/components/keyboard-shortcuts-help.jsx:103
msgid "<0>Esc</0> or <1>Backspace</1>"
msgstr "<0>Gr (Esc)</0> arba <1>Naikinimo klavišas (Backspace)</1>"

#: src/components/keyboard-shortcuts-help.jsx:109
msgid "Focus column in multi-column mode"
msgstr "Fokusuoti stulpelį daugiastulpelių režime"

#: src/components/keyboard-shortcuts-help.jsx:111
msgid "<0>1</0> to <1>9</1>"
msgstr "<0>1</0> iki <1>9</1>"

#: src/components/keyboard-shortcuts-help.jsx:117
msgid "Focus next column in multi-column mode"
msgstr "Fokusuoti sekantį stulpelį daugiastulpelių režime"

#: src/components/keyboard-shortcuts-help.jsx:121
msgid "Focus previous column in multi-column mode"
msgstr "Fokusuoti ankstesnį stulpelį daugiastulpelių režime"

#: src/components/keyboard-shortcuts-help.jsx:125
msgid "Compose new post"
msgstr "Sukurti naują įrašą"

#: src/components/keyboard-shortcuts-help.jsx:129
msgid "Compose new post (new window)"
msgstr "Sukurti naują įrašą (naujas langas)"

#: src/components/keyboard-shortcuts-help.jsx:132
msgid "<0>Shift</0> + <1>c</1>"
msgstr "<0>Lyg2 (Shift)</0> + <1>c</1>"

#: src/components/keyboard-shortcuts-help.jsx:138
msgid "Send post"
msgstr "Siųsti įrašą"

#: src/components/keyboard-shortcuts-help.jsx:140
msgid "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"
msgstr "<0>Vald (Ctrl)</0> + <1>Įvesti (Enter)</1> arba <2>⌘</2> + <3>Įvesti (Enter)</3>"

#: src/components/keyboard-shortcuts-help.jsx:147
#: src/components/nav-menu.jsx:325
#: src/components/search-form.jsx:72
#: src/components/shortcuts-settings.jsx:52
#: src/components/shortcuts-settings.jsx:179
#: src/pages/search.jsx:45
#: src/pages/search.jsx:295
msgid "Search"
msgstr "Paieška"

#: src/components/keyboard-shortcuts-help.jsx:155
msgid "Reply (new window)"
msgstr "Atsakyti (naujas langas)"

#: src/components/keyboard-shortcuts-help.jsx:158
msgid "<0>Shift</0> + <1>r</1>"
msgstr "<0>Lyg2 (Shift)</0> + <1>r</1>"

#: src/components/keyboard-shortcuts-help.jsx:164
msgid "Like (favourite)"
msgstr "Patinka (pamėgti)"

#: src/components/keyboard-shortcuts-help.jsx:166
msgid "<0>l</0> or <1>f</1>"
msgstr "<0>l</0> arba <1>f</1>"

#: src/components/keyboard-shortcuts-help.jsx:172
#: src/components/status.jsx:921
#: src/components/status.jsx:2396
#: src/components/status.jsx:2428
#: src/components/status.jsx:2429
msgid "Boost"
msgstr "Pasidalinti"

#: src/components/keyboard-shortcuts-help.jsx:174
msgid "<0>Shift</0> + <1>b</1>"
msgstr "<0>Lyg2 (Shift)</0> + <1>b</1>"

#: src/components/keyboard-shortcuts-help.jsx:180
#: src/components/status.jsx:1006
#: src/components/status.jsx:2453
#: src/components/status.jsx:2454
msgid "Bookmark"
msgstr "Prid. į žym."

#: src/components/keyboard-shortcuts-help.jsx:184
msgid "Toggle Cloak mode"
msgstr "Perjungti slėpimo režimą"

#: src/components/keyboard-shortcuts-help.jsx:186
msgid "<0>Shift</0> + <1>Alt</1> + <2>k</2>"
msgstr "<0>Lyg2 (Shift)</0> + <1>Alt</1> + <2>k</2>"

#: src/components/list-add-edit.jsx:39
msgid "Edit list"
msgstr "Redaguoti sąrašą"

#: src/components/list-add-edit.jsx:95
msgid "Unable to edit list."
msgstr "Nepavyksta redaguoti sąrašo."

#: src/components/list-add-edit.jsx:96
msgid "Unable to create list."
msgstr "Nepavyksta sukurti sąrašo."

#: src/components/list-add-edit.jsx:124
msgid "Show replies to list members"
msgstr "Rodyti atsakymus sąrašo nariams"

#: src/components/list-add-edit.jsx:127
msgid "Show replies to people I follow"
msgstr "Rodyti atsakymus žmonėms, kuriuos seku"

#: src/components/list-add-edit.jsx:130
msgid "Don't show replies"
msgstr "Nerodyti atsakymų"

#: src/components/list-add-edit.jsx:143
msgid "Hide posts on this list from Home/Following"
msgstr "Paslėpti šio sąrašo pranešimus iš pagrindinio / sekimo"

#: src/components/list-add-edit.jsx:149
#: src/pages/filters.jsx:554
msgid "Create"
msgstr "Kurti"

#: src/components/list-add-edit.jsx:156
msgid "Delete this list?"
msgstr "Ištrinti šį sąrašą?"

#: src/components/list-add-edit.jsx:175
msgid "Unable to delete list."
msgstr "Nepavyksta ištrinti sąrašo."

#: src/components/media-alt-modal.jsx:38
#: src/components/media.jsx:50
msgid "Media description"
msgstr "Medijos aprašymas"

#: src/components/media-alt-modal.jsx:57
#: src/components/status.jsx:1050
#: src/components/status.jsx:1077
#: src/components/translation-block.jsx:195
msgid "Translate"
msgstr "Versti"

#: src/components/media-alt-modal.jsx:68
#: src/components/status.jsx:1064
#: src/components/status.jsx:1091
msgid "Speak"
msgstr "Kalbėti"

#: src/components/media-modal.jsx:368
msgid "Open original media in new window"
msgstr "Atidaryti originalią mediją naujame lange"

#: src/components/media-modal.jsx:372
msgid "Open original media"
msgstr "Atidaryti originalią mediją"

#: src/components/media-modal.jsx:388
msgid "Attempting to describe image. Please wait…"
msgstr "Bandymas apibūdinti vaizdą. Palauk…"

#: src/components/media-modal.jsx:403
msgid "Failed to describe image"
msgstr "Nepavyko apibūdinti vaizdo."

#: src/components/media-modal.jsx:413
msgid "Describe image…"
msgstr "Apibūdinti vaizdą…"

#: src/components/media-modal.jsx:436
msgid "View post"
msgstr "Peržiūrėti įrašą"

#: src/components/media-post.jsx:127
msgid "Sensitive media"
msgstr "Jautri medija"

#: src/components/media-post.jsx:132
msgid "Filtered: {filterTitleStr}"
msgstr "Filtruota: {filterTitleStr}"

#: src/components/media-post.jsx:133
#: src/components/status.jsx:3543
#: src/components/status.jsx:3639
#: src/components/status.jsx:3717
#: src/components/timeline.jsx:973
#: src/pages/catchup.jsx:75
#: src/pages/catchup.jsx:1876
msgid "Filtered"
msgstr "Filtruota"

#: src/components/modals.jsx:72
msgid "Post published. Check it out."
msgstr "Įrašas paskelbtas. Peržiūrėk."

#: src/components/modals.jsx:73
msgid "Reply posted. Check it out."
msgstr "Atsakymas paskelbtas. Peržiūrėk."

#: src/components/modals.jsx:74
msgid "Post updated. Check it out."
msgstr "Įrašas atnaujintas. Peržiūrėk."

#: src/components/nav-menu.jsx:117
msgid "Menu"
msgstr "Meniu"

#: src/components/nav-menu.jsx:153
msgid "Reload page now to update?"
msgstr "Perkrauti puslapį dabar, kad atnaujinti?"

#: src/components/nav-menu.jsx:165
msgid "New update available…"
msgstr "Yra naujas naujinimas…"

#. js-lingui-explicit-id
#: src/components/nav-menu.jsx:184
#: src/components/shortcuts-settings.jsx:140
#: src/pages/following.jsx:22
#: src/pages/following.jsx:141
msgid "following.title"
msgstr "Sekimai"

#: src/components/nav-menu.jsx:191
#: src/pages/catchup.jsx:871
msgid "Catch-up"
msgstr "Pasivijimas"

#: src/components/nav-menu.jsx:198
#: src/components/shortcuts-settings.jsx:58
#: src/components/shortcuts-settings.jsx:146
#: src/pages/home.jsx:224
#: src/pages/mentions.jsx:20
#: src/pages/mentions.jsx:167
#: src/pages/settings.jsx:1145
#: src/pages/trending.jsx:381
msgid "Mentions"
msgstr "Paminėjimai"

#: src/components/nav-menu.jsx:205
#: src/components/shortcuts-settings.jsx:49
#: src/components/shortcuts-settings.jsx:152
#: src/pages/filters.jsx:24
#: src/pages/home.jsx:84
#: src/pages/home.jsx:184
#: src/pages/notifications.jsx:112
#: src/pages/notifications.jsx:524
msgid "Notifications"
msgstr "Pranešimai"

#: src/components/nav-menu.jsx:208
msgid "New"
msgstr "Naujas"

#: src/components/nav-menu.jsx:219
msgid "Profile"
msgstr "Profilis"

#: src/components/nav-menu.jsx:227
#: src/components/shortcuts-settings.jsx:54
#: src/components/shortcuts-settings.jsx:195
#: src/pages/bookmarks.jsx:11
#: src/pages/bookmarks.jsx:23
msgid "Bookmarks"
msgstr "Žymės"

#: src/components/nav-menu.jsx:247
#: src/components/shortcuts-settings.jsx:55
#: src/components/shortcuts-settings.jsx:201
#: src/pages/catchup.jsx:1446
#: src/pages/catchup.jsx:2062
#: src/pages/favourites.jsx:11
#: src/pages/favourites.jsx:23
#: src/pages/settings.jsx:1149
msgid "Likes"
msgstr "Patiktukų"

#: src/components/nav-menu.jsx:253
#: src/pages/followed-hashtags.jsx:14
#: src/pages/followed-hashtags.jsx:44
msgid "Followed Hashtags"
msgstr "Sekamos saitažodžiai"

#: src/components/nav-menu.jsx:261
#: src/pages/account-statuses.jsx:331
#: src/pages/filters.jsx:54
#: src/pages/filters.jsx:93
#: src/pages/hashtag.jsx:339
msgid "Filters"
msgstr "Filtrai"

#: src/components/nav-menu.jsx:269
msgid "Muted users"
msgstr "Nutildyti naudotojai"

#: src/components/nav-menu.jsx:277
msgid "Muted users…"
msgstr "Nutildyti naudotojai…"

#: src/components/nav-menu.jsx:284
msgid "Blocked users"
msgstr "Užblokuoti naudotojai"

#: src/components/nav-menu.jsx:292
msgid "Blocked users…"
msgstr "Užblokuoti naudotojai…"

#: src/components/nav-menu.jsx:304
msgid "Accounts…"
msgstr "Paskyros…"

#: src/components/nav-menu.jsx:314
#: src/pages/login.jsx:189
#: src/pages/status.jsx:835
#: src/pages/welcome.jsx:64
msgid "Log in"
msgstr "Prisijungti"

#: src/components/nav-menu.jsx:331
#: src/components/shortcuts-settings.jsx:57
#: src/components/shortcuts-settings.jsx:172
#: src/pages/trending.jsx:441
msgid "Trending"
msgstr "Tendencinga"

#: src/components/nav-menu.jsx:343
#: src/components/shortcuts-settings.jsx:165
msgid "Federated"
msgstr "Federacinis"

#: src/components/nav-menu.jsx:366
msgid "Shortcuts / Columns…"
msgstr "Trumposios nuorodos / stulpeliai…"

#: src/components/nav-menu.jsx:376
#: src/components/nav-menu.jsx:390
msgid "Settings…"
msgstr "Nustatymai…"

#: src/components/nav-menu.jsx:420
#: src/components/nav-menu.jsx:447
#: src/components/shortcuts-settings.jsx:50
#: src/components/shortcuts-settings.jsx:158
#: src/pages/list.jsx:126
#: src/pages/lists.jsx:16
#: src/pages/lists.jsx:50
msgid "Lists"
msgstr "Sąrašai"

#: src/components/nav-menu.jsx:428
#: src/components/shortcuts.jsx:215
#: src/pages/list.jsx:133
msgid "All Lists"
msgstr "Visi sąrašai"

#: src/components/notification-service.jsx:160
msgid "Notification"
msgstr "Pranešimas"

#: src/components/notification-service.jsx:166
msgid "This notification is from your other account."
msgstr "Šis pranešimas yra iš kitos tavo paskyros."

#: src/components/notification-service.jsx:195
msgid "View all notifications"
msgstr "Peržiūrėti visus pranešimus"

#: src/components/notification.jsx:70
msgid "{account} reacted to your post with {emojiObject}"
msgstr "{account} sureagavo į tavo įrašą su {emojiObject}"

#: src/components/notification.jsx:77
msgid "{account} published a post."
msgstr "{account} paskelbė įrašą."

#: src/components/notification.jsx:85
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted your reply.} other {{account} boosted your post.}}} other {{account} boosted {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted your reply.} other {<2><3>{1}</3> people</2> boosted your post.}}}}"
msgstr ""

#: src/components/notification.jsx:128
msgid "{count, plural, =1 {{account} followed you.} other {<0><1>{0}</1> people</0> followed you.}}"
msgstr "{count, plural, one {{0} seka tave.} few {<0><1>{0}</1> žmonės</0> seka tave.} many {<0><1>{0}</1> žmones</0> seka tave.}=1 {{account}} other {<0><1>{0}</1> žmonių</0> seka tave.}}"

#: src/components/notification.jsx:142
msgid "{account} requested to follow you."
msgstr "{account} paprašė tave sekti."

#: src/components/notification.jsx:151
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} liked your reply.} other {{account} liked your post.}}} other {{account} liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> liked your reply.} other {<2><3>{1}</3> people</2> liked your post.}}}}"
msgstr ""

#: src/components/notification.jsx:193
msgid "A poll you have voted in or created has ended."
msgstr "Baigėsi apklausa, kurioje balsavai arba kurią sukūrei."

#: src/components/notification.jsx:194
msgid "A poll you have created has ended."
msgstr ""

#: src/components/notification.jsx:195
msgid "A poll you have voted in has ended."
msgstr ""

#: src/components/notification.jsx:196
msgid "A post you interacted with has been edited."
msgstr ""

#: src/components/notification.jsx:204
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted & liked your reply.} other {{account} boosted & liked your post.}}} other {{account} boosted & liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted & liked your reply.} other {<2><3>{1}</3> people</2> boosted & liked your post.}}}}"
msgstr ""

#: src/components/notification.jsx:246
msgid "{account} signed up."
msgstr ""

#: src/components/notification.jsx:248
msgid "{account} reported {targetAccount}"
msgstr ""

#: src/components/notification.jsx:253
msgid "Lost connections with <0>{name}</0>."
msgstr ""

#: src/components/notification.jsx:259
msgid "Moderation warning"
msgstr "Prižiūrėjimo įspėjimas"

#: src/components/notification.jsx:269
msgid "An admin from <0>{from}</0> has suspended <1>{targetName}</1>, which means you can no longer receive updates from them or interact with them."
msgstr "Administratorius (-ė) iš <0>{from}</0> pristabdė <1>{targetName}</1>, o tai reiškia, kad nebegali gauti iš jų naujienų ir su jais bendrauti."

#: src/components/notification.jsx:275
msgid "An admin from <0>{from}</0> has blocked <1>{targetName}</1>. Affected followers: {followersCount}, followings: {followingCount}."
msgstr ""

#: src/components/notification.jsx:281
msgid "You have blocked <0>{targetName}</0>. Removed followers: {followersCount}, followings: {followingCount}."
msgstr "Užblokavote <0>{targetName}</0>. Pašalinti sekėjai: {followersCount}, sekimai: {followingCount}."

#: src/components/notification.jsx:289
msgid "Your account has received a moderation warning."
msgstr "Tavo paskyra gavo prižiūrėjimo įspėjimą."

#: src/components/notification.jsx:290
msgid "Your account has been disabled."
msgstr "Tavo paskyra buvo išjungta."

#: src/components/notification.jsx:291
msgid "Some of your posts have been marked as sensitive."
msgstr "Kai kurie tavo įrašai buvo pažymėtos kaip jautrios."

#: src/components/notification.jsx:292
msgid "Some of your posts have been deleted."
msgstr "Kai kurios tavo įrašai buvo ištrinti."

#: src/components/notification.jsx:293
msgid "Your posts will be marked as sensitive from now on."
msgstr "Nuo šiol tavo įrašai bus pažymėti kaip jautrūs."

#: src/components/notification.jsx:294
msgid "Your account has been limited."
msgstr "Tavo paskyra buvo apribota."

#: src/components/notification.jsx:295
msgid "Your account has been suspended."
msgstr "Tavo paskyra buvo pristabdyta."

#: src/components/notification.jsx:369
msgid "[Unknown notification type: {type}]"
msgstr "[Nežinomas pranešimo tipas: {type}]"

#: src/components/notification.jsx:434
#: src/components/status.jsx:1020
#: src/components/status.jsx:1030
msgid "Boosted/Liked by…"
msgstr "Pasidalino / patiko…"

#: src/components/notification.jsx:435
msgid "Liked by…"
msgstr "Patiko…"

#: src/components/notification.jsx:436
msgid "Boosted by…"
msgstr "Pasidalino…"

#: src/components/notification.jsx:437
msgid "Followed by…"
msgstr "Seka…"

#: src/components/notification.jsx:508
#: src/components/notification.jsx:524
msgid "Learn more <0/>"
msgstr "Sužinoti daugiau <0/>"

#: src/components/notification.jsx:756
#: src/components/status.jsx:251
msgid "Read more →"
msgstr "Skaityti daugiau →"

#: src/components/poll.jsx:110
msgid "Voted"
msgstr "Balsuota"

#: src/components/poll.jsx:116
msgid "{optionVotesCount, plural, one {# vote} other {# votes}}"
msgstr "{optionVotesCount, plural, one {# balsas} few {# balsai} many {# balso} other {# balsų}}"

#: src/components/poll.jsx:136
#: src/components/poll.jsx:219
#: src/components/poll.jsx:223
msgid "Hide results"
msgstr "Slėpti rezultatus"

#: src/components/poll.jsx:185
msgid "Vote"
msgstr "Balsuoti"

#: src/components/poll.jsx:205
#: src/components/poll.jsx:207
#: src/pages/status.jsx:1201
#: src/pages/status.jsx:1224
msgid "Refresh"
msgstr "Atnaujinti"

#: src/components/poll.jsx:219
#: src/components/poll.jsx:223
msgid "Show results"
msgstr "Rodyti rezultatus"

#: src/components/poll.jsx:228
msgid "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"
msgstr "{votesCount, plural, one {<0>{0}</0> balsas} few {<1>{1}</1> balsai} many {<1>{1}</1> balso} other {<1>{1}</1> balsų}}"

#: src/components/poll.jsx:245
msgid "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"
msgstr "{votersCount, plural, one {<0>{0}</0> balsuotojas} few {<1>{1}</1> balsuotojai} many {<1>{1}</1> balsuotojo} other {<1>{1}</1> balsuotojų}}"

#: src/components/poll.jsx:265
msgid "Ended <0/>"
msgstr "Baigėsi <0/>"

#: src/components/poll.jsx:269
msgid "Ended"
msgstr "Baigėsi"

#: src/components/poll.jsx:272
msgid "Ending <0/>"
msgstr "Baigsis <0/>"

#: src/components/poll.jsx:276
msgid "Ending"
msgstr "Baigsis"

#. Relative time in seconds, as short as possible
#: src/components/relative-time.jsx:57
msgid "{0}s"
msgstr "{0} sek."

#. Relative time in minutes, as short as possible
#: src/components/relative-time.jsx:62
msgid "{0}m"
msgstr "{0} min."

#. Relative time in hours, as short as possible
#: src/components/relative-time.jsx:67
msgid "{0}h"
msgstr "{0} val."

#: src/components/report-modal.jsx:29
msgid "Spam"
msgstr "Brukalas"

#: src/components/report-modal.jsx:30
msgid "Malicious links, fake engagement, or repetitive replies"
msgstr "Kenkėjiškos nuorodos, netikras įsitraukimas arba pasikartojantys atsakymai"

#: src/components/report-modal.jsx:33
msgid "Illegal"
msgstr "Neteisėta"

#: src/components/report-modal.jsx:34
msgid "Violates the law of your or the server's country"
msgstr "Pažeidžia tavo arba serverio šalies įstatymus"

#: src/components/report-modal.jsx:37
msgid "Server rule violation"
msgstr "Serverio taisyklių pažeidimas"

#: src/components/report-modal.jsx:38
msgid "Breaks specific server rules"
msgstr "Pažeidžia konkrečias serverio taisykles"

#: src/components/report-modal.jsx:39
msgid "Violation"
msgstr "Pažeidimas"

#: src/components/report-modal.jsx:42
msgid "Other"
msgstr "Kita"

#: src/components/report-modal.jsx:43
msgid "Issue doesn't fit other categories"
msgstr "Problema netinka kitoms kategorijoms"

#: src/components/report-modal.jsx:68
msgid "Report Post"
msgstr "Pranešti apie įrašą"

#: src/components/report-modal.jsx:68
msgid "Report @{username}"
msgstr "Pranešti apie @{username}"

#: src/components/report-modal.jsx:104
msgid "Pending review"
msgstr "Laukiama apžvalgos"

#: src/components/report-modal.jsx:146
msgid "Post reported"
msgstr ""

#: src/components/report-modal.jsx:146
msgid "Profile reported"
msgstr ""

#: src/components/report-modal.jsx:154
msgid "Unable to report post"
msgstr ""

#: src/components/report-modal.jsx:155
msgid "Unable to report profile"
msgstr ""

#: src/components/report-modal.jsx:163
msgid "What's the issue with this post?"
msgstr ""

#: src/components/report-modal.jsx:164
msgid "What's the issue with this profile?"
msgstr ""

#: src/components/report-modal.jsx:233
msgid "Additional info"
msgstr ""

#: src/components/report-modal.jsx:256
msgid "Forward to <0>{domain}</0>"
msgstr ""

#: src/components/report-modal.jsx:266
msgid "Send Report"
msgstr ""

#: src/components/report-modal.jsx:275
msgid "Muted {username}"
msgstr ""

#: src/components/report-modal.jsx:278
msgid "Unable to mute {username}"
msgstr ""

#: src/components/report-modal.jsx:283
msgid "Send Report <0>+ Mute profile</0>"
msgstr ""

#: src/components/report-modal.jsx:294
msgid "Blocked {username}"
msgstr "Užblokuotas {username}"

#: src/components/report-modal.jsx:297
msgid "Unable to block {username}"
msgstr "Nepavyksta užblokuoti {username}."

#: src/components/report-modal.jsx:302
msgid "Send Report <0>+ Block profile</0>"
msgstr "Siųsti ataskaitą <0>+ blokuoti profilį</0>"

#: src/components/search-form.jsx:202
msgid "{query} <0>‒ accounts, hashtags & posts</0>"
msgstr "{query} <0>‒ paskyros, saitažodžiai ir įrašai</0>"

#: src/components/search-form.jsx:215
msgid "Posts with <0>{query}</0>"
msgstr "Įrašai su <0>{query}</0>"

#: src/components/search-form.jsx:227
msgid "Posts tagged with <0>#{0}</0>"
msgstr "Įrašai pažymėti su <0>#{0}</0>"

#: src/components/search-form.jsx:241
msgid "Look up <0>{query}</0>"
msgstr "Ieškoti <0>{query}</0>"

#: src/components/search-form.jsx:252
msgid "Accounts with <0>{query}</0>"
msgstr "Paskyros su <0>{query}</0>"

#: src/components/shortcuts-settings.jsx:48
msgid "Home / Following"
msgstr "Pagrindinis / sekimai"

#: src/components/shortcuts-settings.jsx:51
msgid "Public (Local / Federated)"
msgstr "Viešieji (vietiniai / federaciniai)"

#: src/components/shortcuts-settings.jsx:53
msgid "Account"
msgstr "Paskyra"

#: src/components/shortcuts-settings.jsx:56
msgid "Hashtag"
msgstr "Saitažodis"

#: src/components/shortcuts-settings.jsx:63
msgid "List ID"
msgstr "Sąrašo ID"

#: src/components/shortcuts-settings.jsx:70
msgid "Local only"
msgstr "Tik vietinė"

#: src/components/shortcuts-settings.jsx:75
#: src/components/shortcuts-settings.jsx:84
#: src/components/shortcuts-settings.jsx:122
#: src/pages/login.jsx:193
msgid "Instance"
msgstr "Serveris"

#: src/components/shortcuts-settings.jsx:78
#: src/components/shortcuts-settings.jsx:87
#: src/components/shortcuts-settings.jsx:125
msgid "Optional, e.g. mastodon.social"
msgstr "Pasirinktinis, pvz., mastodon.social"

#: src/components/shortcuts-settings.jsx:93
msgid "Search term"
msgstr "Paieškos terminas"

#: src/components/shortcuts-settings.jsx:96
msgid "Optional, unless for multi-column mode"
msgstr "Pasirinktinis, nebent naudojamas daugiastulpelių režimas"

#: src/components/shortcuts-settings.jsx:113
msgid "e.g. PixelArt (Max 5, space-separated)"
msgstr "pvz., „PixelArt“ (ne daugiau kaip 5, atskirti tarpais)"

#: src/components/shortcuts-settings.jsx:117
#: src/pages/hashtag.jsx:355
msgid "Media only"
msgstr "Tik medija"

#: src/components/shortcuts-settings.jsx:235
#: src/components/shortcuts.jsx:192
msgid "Shortcuts"
msgstr "Trumposios nuorodos"

#: src/components/shortcuts-settings.jsx:243
msgid "beta"
msgstr "beta versija"

#: src/components/shortcuts-settings.jsx:249
msgid "Specify a list of shortcuts that'll appear as:"
msgstr "Nurodyk trumpųjų nuorodų sąrašą, kuris bus rodomas kaip:"

#: src/components/shortcuts-settings.jsx:255
msgid "Floating button"
msgstr "Slankusis mygtukas"

#: src/components/shortcuts-settings.jsx:260
msgid "Tab/Menu bar"
msgstr "Skirtukas / meniu juosta"

#: src/components/shortcuts-settings.jsx:265
msgid "Multi-column"
msgstr "Daugiastulpelių"

#: src/components/shortcuts-settings.jsx:332
msgid "Not available in current view mode"
msgstr "Nepasiekiama dabartiniame rodinio režime."

#: src/components/shortcuts-settings.jsx:351
msgid "Move up"
msgstr "Perkelti aukštyn"

#: src/components/shortcuts-settings.jsx:367
msgid "Move down"
msgstr "Perkelti žemyn"

#: src/components/shortcuts-settings.jsx:379
#: src/components/status.jsx:1298
#: src/pages/list.jsx:170
msgid "Edit"
msgstr "Redaguoti"

#: src/components/shortcuts-settings.jsx:400
msgid "Add more than one shortcut/column to make this work."
msgstr "Pridėk daugiau nei vieną trumpąją nuorodą / stulpelį, kad tai veiktų."

#: src/components/shortcuts-settings.jsx:411
msgid "No columns yet. Tap on the Add column button."
msgstr "Kol kas nėra stulpelių. Paliesk mygtuką Pridėti stulpelį."

#: src/components/shortcuts-settings.jsx:412
msgid "No shortcuts yet. Tap on the Add shortcut button."
msgstr "Kol kas nėra trumpųjų nuorodų. Paliesk mygtuką Pridėti trumpąją nuorodą."

#: src/components/shortcuts-settings.jsx:415
msgid "Not sure what to add?<0/>Try adding <1>Home / Following and Notifications</1> first."
msgstr "Nežinai, ką pridėti?<0/>Pirmiausia pabandyk pridėti <1>Pagrindinis / sekimai ir pranešimai</1>."

#: src/components/shortcuts-settings.jsx:443
msgid "Max {SHORTCUTS_LIMIT} columns"
msgstr "Didžiausias {SHORTCUTS_LIMIT} stulpelių skaičius"

#: src/components/shortcuts-settings.jsx:444
msgid "Max {SHORTCUTS_LIMIT} shortcuts"
msgstr "Didžiausias {SHORTCUTS_LIMIT} trumpųjų nuorodų skaičius"

#: src/components/shortcuts-settings.jsx:458
msgid "Import/export"
msgstr "Importuoti / eksportuoti"

#: src/components/shortcuts-settings.jsx:468
msgid "Add column…"
msgstr "Pridėti stulpelį…"

#: src/components/shortcuts-settings.jsx:469
msgid "Add shortcut…"
msgstr "Pridėti trumpąją nuorodą…"

#: src/components/shortcuts-settings.jsx:516
msgid "Specific list is optional. For multi-column mode, list is required, else the column will not be shown."
msgstr "Konkretus sąrašas neprivalomas. Daugiastulpelių režime sąrašas yra privalomas, kitaip stulpelis nebus rodomas."

#: src/components/shortcuts-settings.jsx:517
msgid "For multi-column mode, search term is required, else the column will not be shown."
msgstr "Daugiastulpelių režime privaloma nurodyti paieškos terminą, kitaip stulpelis nebus rodomas."

#: src/components/shortcuts-settings.jsx:518
msgid "Multiple hashtags are supported. Space-separated."
msgstr "Palaikomi keli saitažodžiai. Atskirti tarpais."

#: src/components/shortcuts-settings.jsx:587
msgid "Edit shortcut"
msgstr "Redaguoti trumpąją nuorodą"

#: src/components/shortcuts-settings.jsx:587
msgid "Add shortcut"
msgstr "Pridėti trumpąją nuorodą"

#: src/components/shortcuts-settings.jsx:623
msgid "Timeline"
msgstr "Laiko skalė"

#: src/components/shortcuts-settings.jsx:649
msgid "List"
msgstr "Sąrašas"

#: src/components/shortcuts-settings.jsx:788
msgid "Import/Export <0>Shortcuts</0>"
msgstr "Importuoti / eksportuoti <0>trumposios nuorodos</0>"

#: src/components/shortcuts-settings.jsx:798
msgid "Import"
msgstr "Importuoti"

#: src/components/shortcuts-settings.jsx:806
msgid "Paste shortcuts here"
msgstr "Įklijuok trumpąsias nuorodas čia"

#: src/components/shortcuts-settings.jsx:822
msgid "Downloading saved shortcuts from instance server…"
msgstr "Atsisiunčiamos išsaugotos trumposios nuorodos iš serverio…"

#: src/components/shortcuts-settings.jsx:851
msgid "Unable to download shortcuts"
msgstr "Nepavyksta atsisiųsti trumpųjų nuorodų."

#: src/components/shortcuts-settings.jsx:854
msgid "Download shortcuts from instance server"
msgstr "Atsisiųsti trumpųjų nuorodų iš serverio"

#: src/components/shortcuts-settings.jsx:912
msgid "* Exists in current shortcuts"
msgstr "* Egzistuoja dabartiniuose trumpuosiuose nuorodose"

#: src/components/shortcuts-settings.jsx:917
msgid "List may not work if it's from a different account."
msgstr "Sąrašas gali neveikti, jei jis yra iš kitos paskyros."

#: src/components/shortcuts-settings.jsx:927
msgid "Invalid settings format"
msgstr "Netinkamas nustatymų formatas"

#: src/components/shortcuts-settings.jsx:935
msgid "Append to current shortcuts?"
msgstr "Pridėti prie esamų trumpųjų nuorodų?"

#: src/components/shortcuts-settings.jsx:938
msgid "Only shortcuts that don’t exist in current shortcuts will be appended."
msgstr "Bus pridėti tik tie trumpieji nuorodos, kurių neegzistuoja dabartinėse trumposiose nuorodose."

#: src/components/shortcuts-settings.jsx:960
msgid "No new shortcuts to import"
msgstr "Nėra naujų trumpųjų nuorodų importuoti"

#: src/components/shortcuts-settings.jsx:975
msgid "Shortcuts imported. Exceeded max {SHORTCUTS_LIMIT}, so the rest are not imported."
msgstr "Importuotos trumposios nuorodos. Viršytas didžiausias {SHORTCUTS_LIMIT} ribą, todėl likusieji neimportuojami."

#: src/components/shortcuts-settings.jsx:976
#: src/components/shortcuts-settings.jsx:1000
msgid "Shortcuts imported"
msgstr "Importuotos trumposios nuorodos"

#: src/components/shortcuts-settings.jsx:986
msgid "Import & append…"
msgstr "Importuoti ir pridėti…"

#: src/components/shortcuts-settings.jsx:994
msgid "Override current shortcuts?"
msgstr "Perrašyti esamas trumpąsias nuorodas?"

#: src/components/shortcuts-settings.jsx:995
msgid "Import shortcuts?"
msgstr "Importuoti trumpąsias nuorodas?"

#: src/components/shortcuts-settings.jsx:1009
msgid "or override…"
msgstr "arba perrašyti…"

#: src/components/shortcuts-settings.jsx:1009
msgid "Import…"
msgstr "Importuoti…"

#: src/components/shortcuts-settings.jsx:1018
msgid "Export"
msgstr "Eksportuoti"

#: src/components/shortcuts-settings.jsx:1033
msgid "Shortcuts copied"
msgstr "Nukopijuotos trumposios nuorodos"

#: src/components/shortcuts-settings.jsx:1036
msgid "Unable to copy shortcuts"
msgstr "Nepavyksta nukopijuoti trumpųjų nuorodų."

#: src/components/shortcuts-settings.jsx:1050
msgid "Shortcut settings copied"
msgstr "Nukopijuoti trumpųjų nuorodų nustatymai"

#: src/components/shortcuts-settings.jsx:1053
msgid "Unable to copy shortcut settings"
msgstr "Nepavyksta nukopijuoti trumpųjų nuorodų nustatymų."

#: src/components/shortcuts-settings.jsx:1083
msgid "Share"
msgstr "Bendrinti"

#: src/components/shortcuts-settings.jsx:1122
msgid "Saving shortcuts to instance server…"
msgstr "Išsaugomos trumpųjų nuorodų į serverį…"

#: src/components/shortcuts-settings.jsx:1129
msgid "Shortcuts saved"
msgstr "Išsaugotos trumposios nuorodos"

#: src/components/shortcuts-settings.jsx:1134
msgid "Unable to save shortcuts"
msgstr "Nepavyksta išsaugoti trumpųjų nuorodų."

#: src/components/shortcuts-settings.jsx:1137
msgid "Sync to instance server"
msgstr "Sinchronizuoti su serveriu"

#: src/components/shortcuts-settings.jsx:1145
msgid "{0, plural, one {# character} other {# characters}}"
msgstr "{0, plural, one {# simbolis} few {# simboliai} many {# simbolio} other {# simbolių}}"

#: src/components/shortcuts-settings.jsx:1157
msgid "Raw Shortcuts JSON"
msgstr "Neapdorotos trumposios nuorodos JSON"

#: src/components/shortcuts-settings.jsx:1170
msgid "Import/export settings from/to instance server (Very experimental)"
msgstr "Importuoti / eksportuoti nustatymus iš / į serverį (labai eksperimentinis)"

#: src/components/status.jsx:522
msgid "<0/> <1>boosted</1>"
msgstr "<0/> <1>pasidalino</1>"

#: src/components/status.jsx:621
msgid "Sorry, your current logged-in instance can't interact with this post from another instance."
msgstr "Atsiprašome, tavo dabartinis prisijungtas serveris negali sąveikauti su šiuo įrašu iš kito serverio."

#: src/components/status.jsx:774
msgid "Unliked @{0}'s post"
msgstr "Panaikintas @{0} patiktuko įrašas"

#: src/components/status.jsx:775
msgid "Liked @{0}'s post"
msgstr "Patiko @{0} įrašas"

#: src/components/status.jsx:814
msgid "Unbookmarked @{0}'s post"
msgstr "Pašalintas @{0} įrašas iš žymių"

#: src/components/status.jsx:815
msgid "Bookmarked @{0}'s post"
msgstr "Pridėtas @{0} įrašas į žymes"

#: src/components/status.jsx:921
#: src/components/status.jsx:983
#: src/components/status.jsx:2396
#: src/components/status.jsx:2428
msgid "Unboost"
msgstr "Nebepasidalinti"

#: src/components/status.jsx:937
#: src/components/status.jsx:2411
msgid "Quote"
msgstr "Cituoti"

#: src/components/status.jsx:945
#: src/components/status.jsx:2420
msgid "Some media have no descriptions."
msgstr "Kai kurios medijos neturi aprašymų."

#: src/components/status.jsx:952
msgid "Old post (<0>{0}</0>)"
msgstr "Senasis įrašas (<0>{0}</0>)"

#: src/components/status.jsx:971
#: src/components/status.jsx:1426
msgid "Unboosted @{0}'s post"
msgstr "Panaikintas @{0} įrašo pasidalinimas"

#: src/components/status.jsx:972
#: src/components/status.jsx:1427
msgid "Boosted @{0}'s post"
msgstr "Pasidalintas @{0} įrašas"

#: src/components/status.jsx:984
msgid "Boost…"
msgstr "Pasidalinti…"

#: src/components/status.jsx:996
#: src/components/status.jsx:1711
#: src/components/status.jsx:2441
msgid "Unlike"
msgstr "Nebepatinka"

#: src/components/status.jsx:997
#: src/components/status.jsx:1711
#: src/components/status.jsx:1712
#: src/components/status.jsx:2441
#: src/components/status.jsx:2442
msgid "Like"
msgstr "Patinka"

#: src/components/status.jsx:1006
#: src/components/status.jsx:2453
msgid "Unbookmark"
msgstr "Pašalinti iš žymių"

#: src/components/status.jsx:1114
msgid "View post by <0>@{0}</0>"
msgstr "Peržiūrėti įrašą, kurį sukūrė <0>@{0}</0>"

#: src/components/status.jsx:1135
msgid "Show Edit History"
msgstr "Rodyti redagavimo istoriją"

#: src/components/status.jsx:1138
msgid "Edited: {editedDateText}"
msgstr "Redaguota: {editedDateText}"

#: src/components/status.jsx:1205
#: src/components/status.jsx:3220
msgid "Embed post"
msgstr "Įterptas įrašas"

#: src/components/status.jsx:1219
msgid "Conversation unmuted"
msgstr "Atšauktas pokalbio nutildymas"

#: src/components/status.jsx:1219
msgid "Conversation muted"
msgstr "Pokalbis nutildytas"

#: src/components/status.jsx:1225
msgid "Unable to unmute conversation"
msgstr "Nepavyksta atšaukti pokalbio nutildymą."

#: src/components/status.jsx:1226
msgid "Unable to mute conversation"
msgstr "Nepavyksta nutildyti pokalbio."

#: src/components/status.jsx:1235
msgid "Unmute conversation"
msgstr "Atšaukti pokalbio nutildymą"

#: src/components/status.jsx:1242
msgid "Mute conversation"
msgstr "Nutildyti pokalbį"

#: src/components/status.jsx:1258
msgid "Post unpinned from profile"
msgstr "Įrašas atsegtas iš profilio"

#: src/components/status.jsx:1259
msgid "Post pinned to profile"
msgstr "Įrašas prisegtas prie profilio"

#: src/components/status.jsx:1264
msgid "Unable to unpin post"
msgstr "Nepavyksta atsegti įrašo."

#: src/components/status.jsx:1264
msgid "Unable to pin post"
msgstr "Nepavyksta atsegti įrašo."

#: src/components/status.jsx:1273
msgid "Unpin from profile"
msgstr "Atsegti iš profilio"

#: src/components/status.jsx:1280
msgid "Pin to profile"
msgstr "Prisegti prie profilio"

#: src/components/status.jsx:1309
msgid "Delete this post?"
msgstr "Ištrinti šį įrašą?"

#: src/components/status.jsx:1325
msgid "Post deleted"
msgstr "Įrašas ištrintas"

#: src/components/status.jsx:1328
msgid "Unable to delete post"
msgstr "Nepavyksta ištrinti įrašo."

#: src/components/status.jsx:1356
msgid "Report post…"
msgstr "Pranešti apie įrašą…"

#: src/components/status.jsx:1712
#: src/components/status.jsx:1748
#: src/components/status.jsx:2442
msgid "Liked"
msgstr "Patinka"

#: src/components/status.jsx:1745
#: src/components/status.jsx:2429
msgid "Boosted"
msgstr "Pasidalinta"

#: src/components/status.jsx:1755
#: src/components/status.jsx:2454
msgid "Bookmarked"
msgstr "Pridėta"

#: src/components/status.jsx:1759
msgid "Pinned"
msgstr "Prisegta"

#: src/components/status.jsx:1804
#: src/components/status.jsx:2260
msgid "Deleted"
msgstr "Ištrinta"

#: src/components/status.jsx:1845
msgid "{repliesCount, plural, one {# reply} other {# replies}}"
msgstr "{repliesCount, plural, one {# atsakymas} few {# atsakymai} many {# atsakymo} other {# atsakymų}}"

#: src/components/status.jsx:1934
msgid "Thread{0}"
msgstr "Gija{0}"

#: src/components/status.jsx:2010
#: src/components/status.jsx:2072
#: src/components/status.jsx:2157
msgid "Show less"
msgstr "Rodyti mažiau"

#: src/components/status.jsx:2010
#: src/components/status.jsx:2072
msgid "Show content"
msgstr "Rodyti turinį"

#: src/components/status.jsx:2157
msgid "Show media"
msgstr "Rodyti mediją"

#: src/components/status.jsx:2294
msgid "Edited"
msgstr "Redaguota"

#: src/components/status.jsx:2371
msgid "Comments"
msgstr "Komentarai"

#. More from [Author]
#: src/components/status.jsx:2680
msgid "More from <0/>"
msgstr "Daugiau iš <0/>"

#: src/components/status.jsx:2981
msgid "Edit History"
msgstr "Redagavimo istoriją"

#: src/components/status.jsx:2985
msgid "Failed to load history"
msgstr "Nepavyko įkelti istorijos."

#: src/components/status.jsx:2990
msgid "Loading…"
msgstr "Įkeliama…"

#: src/components/status.jsx:3225
msgid "HTML Code"
msgstr "HTML kodas"

#: src/components/status.jsx:3242
msgid "HTML code copied"
msgstr "Nukopijuotas HTML kodas"

#: src/components/status.jsx:3245
msgid "Unable to copy HTML code"
msgstr "Nepavyksta nukopijuoti HTML kodo."

#: src/components/status.jsx:3257
msgid "Media attachments:"
msgstr "Medijos priedai:"

#: src/components/status.jsx:3279
msgid "Account Emojis:"
msgstr "Paskyros jaustukai:"

#: src/components/status.jsx:3310
#: src/components/status.jsx:3355
msgid "static URL"
msgstr "statinis URL"

#: src/components/status.jsx:3324
msgid "Emojis:"
msgstr "Jaustukai:"

#: src/components/status.jsx:3369
msgid "Notes:"
msgstr "Pastabos:"

#: src/components/status.jsx:3373
msgid "This is static, unstyled and scriptless. You may need to apply your own styles and edit as needed."
msgstr "Tai – statiškas, nestilingas ir be skriptis. Gali reikėti taikyti savo stilius ir redaguoti pagal poreikį."

#: src/components/status.jsx:3379
msgid "Polls are not interactive, becomes a list with vote counts."
msgstr "Apklausos nėra interaktyvios, tampa sąrašu su balsų skaičiais."

#: src/components/status.jsx:3384
msgid "Media attachments can be images, videos, audios or any file types."
msgstr "Medijos priedai gali būti vaizdai, vaizdo įrašai, garso įrašai arba bet kokio tipo failai."

#: src/components/status.jsx:3390
msgid "Post could be edited or deleted later."
msgstr "Įrašas gali būti redaguojamas arba ištrintas vėliau."

#: src/components/status.jsx:3396
msgid "Preview"
msgstr "Peržiūrėti"

#: src/components/status.jsx:3405
msgid "Note: This preview is lightly styled."
msgstr "Pastaba: ši peržiūra yra šiek tiek stilizuota."

#. [Name] [Visibility icon] boosted
#: src/components/status.jsx:3647
msgid "<0/> <1/> boosted"
msgstr "<0/> <1/> pasidalino"

#: src/components/timeline.jsx:453
#: src/pages/settings.jsx:1173
msgid "New posts"
msgstr "Nauji įrašai"

#: src/components/timeline.jsx:554
#: src/pages/home.jsx:213
#: src/pages/notifications.jsx:824
#: src/pages/status.jsx:988
#: src/pages/status.jsx:1361
msgid "Try again"
msgstr "Bandyti dar kartą"

#: src/components/timeline.jsx:588
msgid "{0, plural, one {# Boost} other {# Boosts}}"
msgstr "{0, plural, one {# pasidalinimas} few {# pasidalinimai} many {# pasidalinimo} other {# pasidalinimų}}"

#: src/components/timeline.jsx:593
msgid "Pinned posts"
msgstr "Prisegti įrašai"

#: src/components/timeline.jsx:946
#: src/components/timeline.jsx:953
#: src/pages/catchup.jsx:1893
msgid "Thread"
msgstr "Gija"

#: src/components/timeline.jsx:968
msgid "<0>Filtered</0>: <1>{0}</1>"
msgstr "<0>Filtruota</0>: <1>{0}</1>"

#: src/components/translation-block.jsx:152
msgid "Auto-translated from {sourceLangText}"
msgstr "Automatiškai išversta iš {sourceLangText}"

#: src/components/translation-block.jsx:190
msgid "Translating…"
msgstr "Verčiama…"

#: src/components/translation-block.jsx:193
msgid "Translate from {sourceLangText} (auto-detected)"
msgstr "Versti iš {sourceLangText} (automatiškai aptikta)"

#: src/components/translation-block.jsx:194
msgid "Translate from {sourceLangText}"
msgstr "Versti iš {sourceLangText}"

#: src/components/translation-block.jsx:222
msgid "Auto ({0})"
msgstr "Automatinis ({0})"

#: src/components/translation-block.jsx:235
msgid "Failed to translate"
msgstr "Nepavyko išversti."

#: src/compose.jsx:32
msgid "Editing source status"
msgstr "Šaltinio būsenos redagavimas"

#: src/compose.jsx:34
msgid "Replying to @{0}"
msgstr "Atsakant į @{0}"

#: src/compose.jsx:62
msgid "You may close this page now."
msgstr "Gali dabar uždaryti šį puslapį."

#: src/compose.jsx:70
msgid "Close window"
msgstr "Uždaryti langą"

#: src/compose.jsx:86
msgid "Login required."
msgstr "Privalomas prisijungimas."

#: src/compose.jsx:90
#: src/pages/http-route.jsx:91
#: src/pages/login.jsx:270
msgid "Go home"
msgstr "Eiti į pagrindinį"

#: src/pages/account-statuses.jsx:233
msgid "Account posts"
msgstr "Paskyros įrašai"

#: src/pages/account-statuses.jsx:240
msgid "{accountDisplay} (+ Replies)"
msgstr "{accountDisplay} (+ atsakymai)"

#: src/pages/account-statuses.jsx:242
msgid "{accountDisplay} (- Boosts)"
msgstr "{accountDisplay} (- pasidalinimai)"

#: src/pages/account-statuses.jsx:244
msgid "{accountDisplay} (#{tagged})"
msgstr "{accountDisplay} (#{tagged})"

#: src/pages/account-statuses.jsx:246
msgid "{accountDisplay} (Media)"
msgstr "{accountDisplay} (medija)"

#: src/pages/account-statuses.jsx:252
msgid "{accountDisplay} ({monthYear})"
msgstr "{accountDisplay} ({monthYear})"

#: src/pages/account-statuses.jsx:321
msgid "Clear filters"
msgstr "Valyti filtrus"

#: src/pages/account-statuses.jsx:324
msgid "Clear"
msgstr "Valyti"

#: src/pages/account-statuses.jsx:338
msgid "Showing post with replies"
msgstr "Rodomas įrašas su atsakymais"

#: src/pages/account-statuses.jsx:343
msgid "+ Replies"
msgstr "+ atsakymai"

#: src/pages/account-statuses.jsx:349
msgid "Showing posts without boosts"
msgstr "Rodomi įrašai be pasidalinimų"

#: src/pages/account-statuses.jsx:354
msgid "- Boosts"
msgstr "- pasidalinimai"

#: src/pages/account-statuses.jsx:360
msgid "Showing posts with media"
msgstr "Rodomi įrašai su medija"

#: src/pages/account-statuses.jsx:377
msgid "Showing posts tagged with #{0}"
msgstr "Rodomi įrašai pažymėti su #{0}"

#: src/pages/account-statuses.jsx:416
msgid "Showing posts in {0}"
msgstr "Rodomi įrašai per {0}"

#: src/pages/account-statuses.jsx:505
msgid "Nothing to see here yet."
msgstr "Kol kas nėra čia ką matyti."

#: src/pages/account-statuses.jsx:506
#: src/pages/public.jsx:97
#: src/pages/trending.jsx:449
msgid "Unable to load posts"
msgstr "Nepavyksta įkelti įrašų."

#: src/pages/account-statuses.jsx:547
#: src/pages/account-statuses.jsx:577
msgid "Unable to fetch account info"
msgstr "Nepavyksta gauti paskyros informacijos."

#: src/pages/account-statuses.jsx:554
msgid "Switch to account's instance {0}"
msgstr "Perjungti į paskyros serverį {0}"

#: src/pages/account-statuses.jsx:584
msgid "Switch to my instance (<0>{currentInstance}</0>)"
msgstr "Perjungti į mano serverį (<0>{currentInstance}</0>)"

#: src/pages/account-statuses.jsx:646
msgid "Month"
msgstr "Mėnuo"

#: src/pages/accounts.jsx:55
msgid "Current"
msgstr "Dabartinė"

#: src/pages/accounts.jsx:101
msgid "Default"
msgstr "Numatyta"

#: src/pages/accounts.jsx:123
msgid "Switch to this account"
msgstr "Perjungti į šią paskyrą"

#: src/pages/accounts.jsx:132
msgid "Switch in new tab/window"
msgstr "Perjungti naujame skirtuke / lange"

#: src/pages/accounts.jsx:146
msgid "View profile…"
msgstr "Peržiūrėti profilį…"

#: src/pages/accounts.jsx:163
msgid "Set as default"
msgstr "Nustatyti kaip numatytąjį"

#: src/pages/accounts.jsx:173
msgid "Log out <0>@{0}</0>?"
msgstr "Atsijungti iš <0>@{0}</0>?"

#: src/pages/accounts.jsx:196
msgid "Log out…"
msgstr "Atsijungti…"

#: src/pages/accounts.jsx:209
msgid "Add an existing account"
msgstr "Pridėti esančią paskyrą"

#: src/pages/accounts.jsx:216
msgid "Note: <0>Default</0> account will always be used for first load. Switched accounts will persist during the session."
msgstr "Pastaba: <0>Numatytoji</0> paskyra visada bus naudojama pirmajam įkėlimui. Perjungtos paskyros išliks seanso metu."

#: src/pages/bookmarks.jsx:25
msgid "No bookmarks yet. Go bookmark something!"
msgstr "Kol kas nėra žymių. Eik kažką pridėti į žymes!"

#: src/pages/bookmarks.jsx:26
msgid "Unable to load bookmarks."
msgstr "Nepavyksta įkelti žymių."

#: src/pages/catchup.jsx:54
msgid "last 1 hour"
msgstr "paskutinės 1 valandos"

#: src/pages/catchup.jsx:55
msgid "last 2 hours"
msgstr "paskutinių 2 valandų"

#: src/pages/catchup.jsx:56
msgid "last 3 hours"
msgstr "paskutinių 3 valandų"

#: src/pages/catchup.jsx:57
msgid "last 4 hours"
msgstr "paskutinių 4 valandų"

#: src/pages/catchup.jsx:58
msgid "last 5 hours"
msgstr "paskutinių 5 valandų"

#: src/pages/catchup.jsx:59
msgid "last 6 hours"
msgstr "paskutinių 6 valandų"

#: src/pages/catchup.jsx:60
msgid "last 7 hours"
msgstr "paskutinių 7 valandų"

#: src/pages/catchup.jsx:61
msgid "last 8 hours"
msgstr "paskutinių 8 valandų"

#: src/pages/catchup.jsx:62
msgid "last 9 hours"
msgstr "paskutinių 9 valandų"

#: src/pages/catchup.jsx:63
msgid "last 10 hours"
msgstr "paskutinių 10 valandų"

#: src/pages/catchup.jsx:64
msgid "last 11 hours"
msgstr "paskutinių 11 valandų"

#: src/pages/catchup.jsx:65
msgid "last 12 hours"
msgstr "paskutinių 12 valandų"

#: src/pages/catchup.jsx:66
msgid "beyond 12 hours"
msgstr "po 12 valandų"

#: src/pages/catchup.jsx:73
msgid "Followed tags"
msgstr "Sekamos žymės"

#: src/pages/catchup.jsx:74
msgid "Groups"
msgstr "Grupės"

#: src/pages/catchup.jsx:596
msgid "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"
msgstr "Rodomi {selectedFilterCategory, select, all {visi įrašai} original {originalūs įrašai} replies {atsakymai} boosts {pasidalinimai} followedTags {sekamos žymės} groups {grupės} filtered {filtruojami įrašai}}, {sortBy, select, createdAt {{sortOrder, select, asc {seniausi} desc {naujausi}}} reblogsCount {{sortOrder, select, asc {mažiausiai pasidalinimų} desc {daugiausiai pasidalinimų}}} favouritesCount {{sortOrder, select, asc {mažiausiai patiktukų} desc {daugiausiai patiktukų}}} repliesCount {{sortOrder, select, asc {mažiausiai atsakymų} desc {daugiausiai atsakymų}}} density {{sortOrder, select, asc {mažiausiai tankūs} desc {tankiausi}}}} pirmiausiai {groupBy, select, account {, sugrupuota pagal autorius} other {}}"

#: src/pages/catchup.jsx:882
#: src/pages/catchup.jsx:906
msgid "Catch-up <0>beta</0>"
msgstr "Pasivijimas <0>beta versija</0>"

#: src/pages/catchup.jsx:896
#: src/pages/catchup.jsx:1585
msgid "Help"
msgstr "Žinynas"

#: src/pages/catchup.jsx:912
msgid "What is this?"
msgstr "Kas tai?"

#: src/pages/catchup.jsx:915
msgid "Catch-up is a separate timeline for your followings, offering a high-level view at a glance, with a simple, email-inspired interface to effortlessly sort and filter through posts."
msgstr "Pasivijimo informacija – tai atskira sekimu laiko skalė, suteikianti aukšto lygio peržiūrą iš pirmo žvilgsnio, su paprasta, el. pašto įkvėpta sąsaja, kad būtų galima lengvai rikiuoti ir filtruoti įrašus."

#: src/pages/catchup.jsx:926
msgid "Preview of Catch-up UI"
msgstr "Pasivijimo naudotojo sąsajos peržiūra"

#: src/pages/catchup.jsx:935
msgid "Let's catch up"
msgstr "Pasivykime"

#: src/pages/catchup.jsx:940
msgid "Let's catch up on the posts from your followings."
msgstr "Pasivykime tavo sekimų įrašus."

#: src/pages/catchup.jsx:944
msgid "Show me all posts from…"
msgstr "Rodyti visus įrašus nuo…"

#: src/pages/catchup.jsx:967
msgid "until the max"
msgstr "iki didžiausio"

#: src/pages/catchup.jsx:997
msgid "Catch up"
msgstr "Pasivyti"

#: src/pages/catchup.jsx:1003
msgid "Overlaps with your last catch-up"
msgstr "Sutampa su paskutiniu pasivijimu"

#: src/pages/catchup.jsx:1015
msgid "Until the last catch-up ({0})"
msgstr "Iki paskutinio pasivijimo ({0})"

#: src/pages/catchup.jsx:1024
msgid "Note: your instance might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."
msgstr "Pastaba: tavo serveris gali rodyti ne daugiau kaip 800 įrašų pagrindinėje laiko skalėje, nepaisant laiko intervalo. Gali būti mažiau arba daugiau."

#: src/pages/catchup.jsx:1034
msgid "Previously…"
msgstr "Anksčiau…"

#: src/pages/catchup.jsx:1052
msgid "{0, plural, one {# post} other {# posts}}"
msgstr "{0, plural, one {# įrašas} few {# įrašai} many {# įrašo} other {# įrašų}}"

#: src/pages/catchup.jsx:1062
msgid "Remove this catch-up?"
msgstr "Šalinti šį pasivijimą?"

#: src/pages/catchup.jsx:1065
msgid "Removing Catch-up {0}"
msgstr "Pašalinima {0} pasivijimas"

#: src/pages/catchup.jsx:1069
msgid "Catch-up {0} removed"
msgstr "Pašalintas {0} pasivijimas"

#: src/pages/catchup.jsx:1083
msgid "Note: Only max 3 will be stored. The rest will be automatically removed."
msgstr "Pastaba: bus išsaugota tik ne daugiau kaip 3. Likusios bus automatiškai pašalintos."

#: src/pages/catchup.jsx:1098
msgid "Fetching posts…"
msgstr "Gaunami įrašai…"

#: src/pages/catchup.jsx:1101
msgid "This might take a while."
msgstr "Tai gali šiek tiek užtrukti."

#: src/pages/catchup.jsx:1136
msgid "Reset filters"
msgstr "Atkurti filtrus"

#: src/pages/catchup.jsx:1144
#: src/pages/catchup.jsx:1591
msgid "Top links"
msgstr "Populiariausios nuorodos"

#: src/pages/catchup.jsx:1261
msgid "Shared by {0}"
msgstr "Bendrino {0}"

#: src/pages/catchup.jsx:1316
#: src/pages/mentions.jsx:147
#: src/pages/search.jsx:308
msgid "All"
msgstr "Viskas"

#: src/pages/catchup.jsx:1401
msgid "{0, plural, one {# author} other {# authors}}"
msgstr "{0, plural, one {# autorius} few {# autoriai} many {# autoriaus} other {# autorių}}"

#: src/pages/catchup.jsx:1413
msgid "Sort"
msgstr "Rikiuoti"

#: src/pages/catchup.jsx:1444
msgid "Date"
msgstr "Data"

#: src/pages/catchup.jsx:1448
msgid "Density"
msgstr "Tankumas"

#. js-lingui-explicit-id
#: src/pages/catchup.jsx:1471
msgid "group.filter"
msgstr ""

#: src/pages/catchup.jsx:1486
msgid "Authors"
msgstr "Autoriai"

#: src/pages/catchup.jsx:1487
msgid "None"
msgstr "Nieko"

#: src/pages/catchup.jsx:1503
msgid "Show all authors"
msgstr "Rodyti visus autorius"

#: src/pages/catchup.jsx:1554
msgid "You don't have to read everything."
msgstr "Nebūtina perskaityti viską."

#: src/pages/catchup.jsx:1555
msgid "That's all."
msgstr "Tai viskas."

#: src/pages/catchup.jsx:1563
msgid "Back to top"
msgstr "Grįžti į viršų"

#: src/pages/catchup.jsx:1594
msgid "Links shared by followings, sorted by shared counts, boosts and likes."
msgstr "Nuorodos bendrinamos pagal sekimus, surikiuotos pagal bendrinamų nuorodų skaičių, pasidalinimus ir patiktukus."

#: src/pages/catchup.jsx:1600
msgid "Sort: Density"
msgstr "Rikiuoti: tankumas"

#: src/pages/catchup.jsx:1603
msgid "Posts are sorted by information density or depth. Shorter posts are \"lighter\" while longer posts are \"heavier\". Posts with photos are \"heavier\" than posts without photos."
msgstr "Įrašai rikiuojami pagal informacijos tankumą arba gilumą. Trumpesni įrašai „lengvesni“, o ilgesni – „sunkesni“. Įrašai su nuotraukomis yra „sunkesni“ nei įrašai be nuotraukų."

#: src/pages/catchup.jsx:1610
msgid "Group: Authors"
msgstr "Grupuoti: autoriai"

#: src/pages/catchup.jsx:1613
msgid "Posts are grouped by authors, sorted by posts count per author."
msgstr "Įrašai sugrupuoti pagal autorius, surikiuoti pagal kiekvieno autoriaus įrašų skaičių."

#: src/pages/catchup.jsx:1660
msgid "Next author"
msgstr "Kitas autorius"

#: src/pages/catchup.jsx:1668
msgid "Previous author"
msgstr "Ankstesnis autorius"

#: src/pages/catchup.jsx:1684
msgid "Scroll to top"
msgstr "Slinkti į viršų"

#: src/pages/catchup.jsx:1875
msgid "Filtered: {0}"
msgstr "Filtruota: {0}"

#: src/pages/favourites.jsx:25
msgid "No likes yet. Go like something!"
msgstr "Kol kas nėra patiktukų. Eik kažką pamėgti!"

#: src/pages/favourites.jsx:26
msgid "Unable to load likes."
msgstr "Nepavyksta įkelti patiktukų."

#: src/pages/filters.jsx:23
msgid "Home and lists"
msgstr "Pagrindinis ir sąrašai"

#: src/pages/filters.jsx:25
msgid "Public timelines"
msgstr "Viešieji laiko skalės"

#: src/pages/filters.jsx:26
msgid "Conversations"
msgstr "Pokalbiai"

#: src/pages/filters.jsx:27
msgid "Profiles"
msgstr "Profiliai"

#: src/pages/filters.jsx:42
msgid "Never"
msgstr "Niekada"

#: src/pages/filters.jsx:103
#: src/pages/filters.jsx:228
msgid "New filter"
msgstr "Naujas filtras"

#: src/pages/filters.jsx:151
msgid "{0, plural, one {# filter} other {# filters}}"
msgstr "{0, plural, one {# filtras} few {# filtrai} many {# filtro} other {# filtrų}}"

#: src/pages/filters.jsx:166
msgid "Unable to load filters."
msgstr "Nepavyksta įkelti filtrų."

#: src/pages/filters.jsx:170
msgid "No filters yet."
msgstr "Kol kas nėra filtrų."

#: src/pages/filters.jsx:177
msgid "Add filter"
msgstr "Pridėti filtrą"

#: src/pages/filters.jsx:228
msgid "Edit filter"
msgstr "Redaguoti filtrą"

#: src/pages/filters.jsx:345
msgid "Unable to edit filter"
msgstr "Nepavyksta redaguoti filtro."

#: src/pages/filters.jsx:346
msgid "Unable to create filter"
msgstr "Nepavyksta sukurti filtro."

#: src/pages/filters.jsx:355
msgid "Title"
msgstr "Pavadinimas"

#: src/pages/filters.jsx:396
msgid "Whole word"
msgstr "Visas žodis"

#: src/pages/filters.jsx:422
msgid "No keywords. Add one."
msgstr "Nėra raktažodžių. Pridėk vieną."

#: src/pages/filters.jsx:449
msgid "Add keyword"
msgstr "Pridėti raktažodį"

#: src/pages/filters.jsx:453
msgid "{0, plural, one {# keyword} other {# keywords}}"
msgstr "{0, plural, one {# raktažodis} few {# raktažodžiai} many {# raktažodžio} other {# raktažodžių}}"

#: src/pages/filters.jsx:466
msgid "Filter from…"
msgstr "Filtruoti iš…"

#: src/pages/filters.jsx:492
msgid "* Not implemented yet"
msgstr "* Kol kas nepadaryta"

#: src/pages/filters.jsx:498
msgid "Status: <0><1/></0>"
msgstr "Būsena: <0><1/></0>"

#: src/pages/filters.jsx:507
msgid "Change expiry"
msgstr "Keisti galiojimo laiką"

#: src/pages/filters.jsx:507
msgid "Expiry"
msgstr "Galiojimo laikas"

#: src/pages/filters.jsx:526
msgid "Filtered post will be…"
msgstr "Filtruotas įrašas bus…"

#: src/pages/filters.jsx:536
msgid "minimized"
msgstr "sumažintas"

#: src/pages/filters.jsx:546
msgid "hidden"
msgstr "paslėptas"

#: src/pages/filters.jsx:563
msgid "Delete this filter?"
msgstr "Ištrinti šį filtrą?"

#: src/pages/filters.jsx:576
msgid "Unable to delete filter."
msgstr "Nepavyksta ištrinti filtro."

#: src/pages/filters.jsx:608
msgid "Expired"
msgstr "Nebegalioja"

#: src/pages/filters.jsx:610
msgid "Expiring <0/>"
msgstr "Baigiasi <0/>"

#: src/pages/filters.jsx:614
msgid "Never expires"
msgstr "Niekada nesibaigia"

#: src/pages/followed-hashtags.jsx:70
msgid "{0, plural, one {# hashtag} other {# hashtags}}"
msgstr "{0, plural, one {# saitažodis} few {# saitažodžiai} many {# saitažodžio} other {# saitažodžių}}"

#: src/pages/followed-hashtags.jsx:85
msgid "Unable to load followed hashtags."
msgstr "Nepavyksta įkelti sekamų saitažodžių."

#: src/pages/followed-hashtags.jsx:89
msgid "No hashtags followed yet."
msgstr "Kol kas nėra sekamų saitažodžių."

#: src/pages/following.jsx:143
msgid "Nothing to see here."
msgstr "Nėra ką matyti čia."

#: src/pages/following.jsx:144
#: src/pages/list.jsx:108
msgid "Unable to load posts."
msgstr "Nepavyksta įkelti įrašų."

#: src/pages/hashtag.jsx:55
msgid "{hashtagTitle} (Media only) on {instance}"
msgstr "{hashtagTitle} (tik medija) serveryje {instance}"

#: src/pages/hashtag.jsx:56
msgid "{hashtagTitle} on {instance}"
msgstr "{hashtagTitle} serveryje {instance}"

#: src/pages/hashtag.jsx:58
msgid "{hashtagTitle} (Media only)"
msgstr "{hashtagTitle} (tik medija)"

#: src/pages/hashtag.jsx:59
msgid "{hashtagTitle}"
msgstr "{hashtagTitle}"

#: src/pages/hashtag.jsx:181
msgid "No one has posted anything with this tag yet."
msgstr "Kol kas niekas nieko su šia žyme nepaskelbė."

#: src/pages/hashtag.jsx:182
msgid "Unable to load posts with this tag"
msgstr "Nepavyksta įkelti įrašų su šia žyme."

#: src/pages/hashtag.jsx:208
msgid "Unfollow #{hashtag}?"
msgstr "Nebesekti #{hashtag}?"

#: src/pages/hashtag.jsx:223
msgid "Unfollowed #{hashtag}"
msgstr "Nebesekama #{hashtag}"

#: src/pages/hashtag.jsx:238
msgid "Followed #{hashtag}"
msgstr "Sekama #{hashtag}"

#: src/pages/hashtag.jsx:254
msgid "Following…"
msgstr "Sekama…"

#: src/pages/hashtag.jsx:282
msgid "Unfeatured on profile"
msgstr "Neberodoma profilyje"

#: src/pages/hashtag.jsx:296
msgid "Unable to unfeature on profile"
msgstr "Nepavyksta neberodyti profilyje."

#: src/pages/hashtag.jsx:305
#: src/pages/hashtag.jsx:321
msgid "Featured on profile"
msgstr "Rodoma profilyje"

#: src/pages/hashtag.jsx:328
msgid "Feature on profile"
msgstr "Rodyti profilyje"

#: src/pages/hashtag.jsx:393
msgid "{TOTAL_TAGS_LIMIT, plural, other {Max # tags}}"
msgstr "{TOTAL_TAGS_LIMIT, plural, one {Didžiausia # žymė} few {Didžiausia # žymės} many {Didžiausia # žymes}other {Didžiausia # žymių}}"

#: src/pages/hashtag.jsx:396
msgid "Add hashtag"
msgstr "Pridėti saitažodį"

#: src/pages/hashtag.jsx:428
msgid "Remove hashtag"
msgstr "Šalinti saitažodį"

#: src/pages/hashtag.jsx:442
msgid "{SHORTCUTS_LIMIT, plural, one {Max # shortcut reached. Unable to add shortcut.} other {Max # shortcuts reached. Unable to add shortcut.}}"
msgstr "{SHORTCUTS_LIMIT, plural, one {Pasiektas didžiausias # trumpojo nuorodos. Nepavyksta pridėti trumposios nuorodos.} few {Pasiekti didžiausias # trumpųjų nuorodų. Nepavyksta pridėti trumposios nuorodos.} many {Pasiekta didžiausias # trumpojo nuorodos. Nepavyksta pridėti trumposios nuorodos.} other {Pasiekta didžiausias # trumpųjų nuorodų. Nepavyksta pridėti trumposios nuorodos.}}"

#: src/pages/hashtag.jsx:471
msgid "This shortcut already exists"
msgstr "Ši nuoroda jau egzistuoja."

#: src/pages/hashtag.jsx:474
msgid "Hashtag shortcut added"
msgstr "Pridėtas trumpasis nuorodos saitažodis"

#: src/pages/hashtag.jsx:480
msgid "Add to Shortcuts"
msgstr "Pridėti prie trumpųjų nuorodų"

#: src/pages/hashtag.jsx:486
#: src/pages/public.jsx:139
#: src/pages/trending.jsx:478
msgid "Enter a new instance e.g. \"mastodon.social\""
msgstr "Įvesk naują serverį, pvz., mastodon.social"

#: src/pages/hashtag.jsx:489
#: src/pages/public.jsx:142
#: src/pages/trending.jsx:481
msgid "Invalid instance"
msgstr "Netinkamas serveris."

#: src/pages/hashtag.jsx:503
#: src/pages/public.jsx:156
#: src/pages/trending.jsx:493
msgid "Go to another instance…"
msgstr "Eiti į kitą serverį…"

#: src/pages/hashtag.jsx:516
#: src/pages/public.jsx:169
#: src/pages/trending.jsx:504
msgid "Go to my instance (<0>{currentInstance}</0>)"
msgstr "Eiti į mano serverį (<0>{currentInstance}</0>)"

#: src/pages/home.jsx:209
msgid "Unable to fetch notifications."
msgstr "Nepavyksta gauti pranešimų."

#: src/pages/home.jsx:229
msgid "<0>New</0> <1>Follow Requests</1>"
msgstr "<0>Nauji</0> <1>sekimo prašymai</1>"

#: src/pages/home.jsx:235
msgid "See all"
msgstr "Žiūrėti viską"

#: src/pages/http-route.jsx:68
msgid "Resolving…"
msgstr "Sprendžiama…"

#: src/pages/http-route.jsx:79
msgid "Unable to resolve URL"
msgstr "Nepavyksta išspręsti URL."

#: src/pages/list.jsx:107
msgid "Nothing yet."
msgstr "Kol kas nieko."

#: src/pages/list.jsx:176
#: src/pages/list.jsx:279
msgid "Manage members"
msgstr "Tvarkyti narius"

#: src/pages/list.jsx:313
msgid "Remove <0>@{0}</0> from list?"
msgstr "Pašalinti <0>@{0}</0> iš sąrašo?"

#: src/pages/list.jsx:359
msgid "Remove…"
msgstr "Šalinti…"

#: src/pages/lists.jsx:93
msgid "{0, plural, one {# list} other {# lists}}"
msgstr "{0, plural, one {# sąrašas} few {# sąrašai} many {# sąrašo} other {# sąrašų}}"

#: src/pages/lists.jsx:108
msgid "No lists yet."
msgstr "Kol kas nėra sąrašų."

#: src/pages/login.jsx:109
#: src/pages/login.jsx:122
msgid "Failed to register application"
msgstr "Nepavyko užregistruoti programos."

#: src/pages/login.jsx:208
msgid "instance domain"
msgstr "serverio domenas"

#: src/pages/login.jsx:232
msgid "e.g. “mastodon.social”"
msgstr "pvz., mastodon.social"

#: src/pages/login.jsx:243
msgid "Failed to log in. Please try again or try another instance."
msgstr "Nepavyko prisijungti. Bandyk dar kartą arba išbandyk kitą serverį."

#: src/pages/login.jsx:255
msgid "Continue with {selectedInstanceText}"
msgstr "Tęsti su {selectedInstanceText}"

#: src/pages/login.jsx:256
msgid "Continue"
msgstr "Tęsti"

#: src/pages/login.jsx:264
msgid "Don't have an account? Create one!"
msgstr "Neturi paskyros? Susikurk vieną!"

#: src/pages/mentions.jsx:20
msgid "Private mentions"
msgstr "Privatūs paminėjimai"

#: src/pages/mentions.jsx:159
msgid "Private"
msgstr "Privati"

#: src/pages/mentions.jsx:169
msgid "No one mentioned you :("
msgstr "Niekas tavęs nepaminėjo. :("

#: src/pages/mentions.jsx:170
msgid "Unable to load mentions."
msgstr "Nepavyksta įkelti paminėjimų."

#: src/pages/notifications.jsx:103
msgid "You don't follow"
msgstr "Neseki"

#: src/pages/notifications.jsx:104
msgid "Who don't follow you"
msgstr "Kurie tavęs neseka"

#: src/pages/notifications.jsx:105
msgid "With a new account"
msgstr "Su nauja paskyra"

#: src/pages/notifications.jsx:106
msgid "Who unsolicitedly private mention you"
msgstr "Kurie neprašytai privačiai paminėjo tave"

#: src/pages/notifications.jsx:107
msgid "Who are limited by server moderators"
msgstr "Kurie yra ribojami serverio prižiūrėtojų"

#: src/pages/notifications.jsx:538
#: src/pages/notifications.jsx:872
msgid "Notifications settings"
msgstr "Pranešimų nustatymai"

#: src/pages/notifications.jsx:556
msgid "New notifications"
msgstr "Nauji pranešimai"

#: src/pages/notifications.jsx:567
msgid "{0, plural, one {Announcement} other {Announcements}}"
msgstr "{0, plural, one {Skelbimas} few {Skelbimai} many {Skelbimo} other {Skelbimų}}"

#: src/pages/notifications.jsx:614
#: src/pages/settings.jsx:1161
msgid "Follow requests"
msgstr "Sekimo prašymai"

#: src/pages/notifications.jsx:619
msgid "{0, plural, one {# follow request} other {# follow requests}}"
msgstr "{0, plural, one {# sekimo prašymai} few {# sekimo prašymai} many {# sekimo prašymo} other {# sekimo prašymų}}"

#: src/pages/notifications.jsx:674
msgid "{0, plural, one {Filtered notifications from # person} other {Filtered notifications from # people}}"
msgstr "{0, plural, one {Filtruojami pranešimai iš # žmogaus} few {Filtruojami pranešimai iš # žmonių} many {Filtruojami pranešimai iš # žmogaus} other {Filtruojami pranešimai iš # žmonių}}"

#: src/pages/notifications.jsx:740
msgid "Only mentions"
msgstr "Tik paminėjimus"

#: src/pages/notifications.jsx:744
msgid "Today"
msgstr "Šiandien"

#: src/pages/notifications.jsx:749
msgid "You're all caught up."
msgstr "Viską peržiūrėjai."

#: src/pages/notifications.jsx:772
msgid "Yesterday"
msgstr "Vakar"

#: src/pages/notifications.jsx:820
msgid "Unable to load notifications"
msgstr "Nepavyksta įkelti pranešimų."

#: src/pages/notifications.jsx:899
msgid "Notifications settings updated"
msgstr "Atnaujinti pranešimų nustatymai"

#: src/pages/notifications.jsx:907
msgid "Filter out notifications from people:"
msgstr "Filtruoti pranešimus iš žmonių:"

#: src/pages/notifications.jsx:921
msgid "Filter"
msgstr "Filtruoti"

#: src/pages/notifications.jsx:924
msgid "Ignore"
msgstr "Ignoruoti"

#: src/pages/notifications.jsx:997
msgid "Updated <0>{0}</0>"
msgstr "Atnaujinta <0>{0}</0>"

#: src/pages/notifications.jsx:1065
msgid "View notifications from <0>@{0}</0>"
msgstr "Peržiūrėti pranešimus iš <0>@{0}</0>"

#: src/pages/notifications.jsx:1086
msgid "Notifications from <0>@{0}</0>"
msgstr "Pranešimai iš <0>@{0}</0>"

#: src/pages/notifications.jsx:1153
msgid "Notifications from @{0} will not be filtered from now on."
msgstr "Pranešimai iš @{0} nuo šiol nebus filtruojami."

#: src/pages/notifications.jsx:1158
msgid "Unable to accept notification request"
msgstr "Nepavyksta priimti pranešimo prašymo."

#: src/pages/notifications.jsx:1163
msgid "Allow"
msgstr "Leisti"

#: src/pages/notifications.jsx:1183
msgid "Notifications from @{0} will not show up in Filtered notifications from now on."
msgstr "Pranešimai iš @{0} nuo šiol nebus rodomi filtruotuose pranešimuose."

#: src/pages/notifications.jsx:1188
msgid "Unable to dismiss notification request"
msgstr "Nepavyksta atmesti pranešimo prašymo."

#: src/pages/notifications.jsx:1193
msgid "Dismiss"
msgstr "Atmesti"

#: src/pages/notifications.jsx:1208
msgid "Dismissed"
msgstr "Atmesta"

#: src/pages/public.jsx:27
msgid "Local timeline ({instance})"
msgstr "Vietinė laiko skalė ({instance})"

#: src/pages/public.jsx:28
msgid "Federated timeline ({instance})"
msgstr "Federacinė laiko skalė ({instance})"

#: src/pages/public.jsx:90
msgid "Local timeline"
msgstr "Vietinė laiko skalė"

#: src/pages/public.jsx:90
msgid "Federated timeline"
msgstr "Federacinė laiko skalė"

#: src/pages/public.jsx:96
msgid "No one has posted anything yet."
msgstr "Kol kas niekas nieko nepaskelbė."

#: src/pages/public.jsx:123
msgid "Switch to Federated"
msgstr "Perjungti į federacinę"

#: src/pages/public.jsx:130
msgid "Switch to Local"
msgstr "Perjungti į vietinį"

#: src/pages/search.jsx:49
msgid "Search: {q} (Posts)"
msgstr "Paieška: {q} (įrašai)"

#: src/pages/search.jsx:52
msgid "Search: {q} (Accounts)"
msgstr "Paieška: {q} (paskyros)"

#: src/pages/search.jsx:55
msgid "Search: {q} (Hashtags)"
msgstr "Paieška: {q} (saitažodžiai)"

#: src/pages/search.jsx:58
msgid "Search: {q}"
msgstr "Paieška: {q}"

#: src/pages/search.jsx:318
#: src/pages/search.jsx:400
msgid "Hashtags"
msgstr "Saitažodžiai"

#: src/pages/search.jsx:350
#: src/pages/search.jsx:404
#: src/pages/search.jsx:474
msgid "See more"
msgstr "Žiūrėti daugiau"

#: src/pages/search.jsx:376
msgid "See more accounts"
msgstr "Žiūrėti daugiau paskyrų"

#: src/pages/search.jsx:390
msgid "No accounts found."
msgstr "Paskyrų nerasta."

#: src/pages/search.jsx:446
msgid "See more hashtags"
msgstr "Žiūrėti daugiau saitažodžių"

#: src/pages/search.jsx:460
msgid "No hashtags found."
msgstr "Saitažodžių nerasta."

#: src/pages/search.jsx:504
msgid "See more posts"
msgstr "Žiūrėti daugiau įrašų"

#: src/pages/search.jsx:518
msgid "No posts found."
msgstr "Įrašų nerasta."

#: src/pages/search.jsx:562
msgid "Enter your search term or paste a URL above to get started."
msgstr "Įvesk paieškos terminą arba įklijuok URL, kad pradėtum."

#: src/pages/settings.jsx:82
msgid "Settings"
msgstr "Nustatymai"

#: src/pages/settings.jsx:91
msgid "Appearance"
msgstr "Išvaizda"

#: src/pages/settings.jsx:167
msgid "Light"
msgstr "Šviesi"

#: src/pages/settings.jsx:178
msgid "Dark"
msgstr "Tamsi"

#: src/pages/settings.jsx:191
msgid "Auto"
msgstr "Automatinis"

#: src/pages/settings.jsx:201
msgid "Text size"
msgstr "Teksto dydis"

#. Preview of one character, in smallest size
#. Preview of one character, in largest size
#: src/pages/settings.jsx:206
#: src/pages/settings.jsx:231
msgid "A"
msgstr "A"

#: src/pages/settings.jsx:245
msgid "Display language"
msgstr "Rodymo kalba"

#: src/pages/settings.jsx:254
msgid "Volunteer translations"
msgstr "Atlikti vertimus savanoriškai"

#: src/pages/settings.jsx:265
msgid "Posting"
msgstr "Skelbimas"

#: src/pages/settings.jsx:272
msgid "Default visibility"
msgstr "Numatytasis matomumas"

#: src/pages/settings.jsx:273
#: src/pages/settings.jsx:319
msgid "Synced"
msgstr "Sinchronizuota"

#: src/pages/settings.jsx:298
msgid "Failed to update posting privacy"
msgstr "Nepavyko atnaujinti skelbimo privatumo."

#: src/pages/settings.jsx:321
msgid "Synced to your instance server's settings. <0>Go to your instance ({instance}) for more settings.</0>"
msgstr "Sinchronizuota su serverio nustatymais. <0>Eiti į savo serverį ({instance}), kad sužinoti daugiau nustatymų.</0>"

#: src/pages/settings.jsx:336
msgid "Experiments"
msgstr "Eksperimentai"

#: src/pages/settings.jsx:349
msgid "Auto refresh timeline posts"
msgstr "Automatiškai atnaujinti laiko skalės įrašus"

#: src/pages/settings.jsx:361
msgid "Boosts carousel"
msgstr "Pasidalinimų karuselė"

#: src/pages/settings.jsx:377
msgid "Post translation"
msgstr "Įrašo vertimas"

#: src/pages/settings.jsx:388
msgid "Translate to"
msgstr "Versti į"

#: src/pages/settings.jsx:399
msgid "System language ({systemTargetLanguageText})"
msgstr "Sistemos kalbą ({systemTargetLanguageText})"

#: src/pages/settings.jsx:425
msgid "{0, plural, =0 {Hide \"Translate\" button for:} other {Hide \"Translate\" button for (#):}}"
msgstr "{0, plural, one {Slėpti Versti mygtuką (#):} few {Slėpti Versti mygtuką (#):} many {Slėpti Versti mygtuką (#):}=0 {} other {Slėpti Versti mygtuką (#):}}"

#: src/pages/settings.jsx:479
msgid "Note: This feature uses external translation services, powered by <0>Lingva API</0> & <1>Lingva Translate</1>."
msgstr "Pastaba: ši funkcija naudoja išorines vertimo paslaugas, veikiančias su <0>„Lingva“ API</0> ir <1>„Lingva Translate“</1>."

#: src/pages/settings.jsx:513
msgid "Auto inline translation"
msgstr "Automatinis įterptinis vertimas"

#: src/pages/settings.jsx:517
msgid "Automatically show translation for posts in timeline. Only works for <0>short</0> posts without content warning, media and poll."
msgstr "Automatiškai rodyti vertimą įrašams laiko skalėje. Veikia tik <0>trumpiems</0> įrašams be turinio įspėjimo, medijos ir apklausos."

#: src/pages/settings.jsx:537
msgid "GIF Picker for composer"
msgstr "GIF parinkiklis rengyklei"

#: src/pages/settings.jsx:541
msgid "Note: This feature uses external GIF search service, powered by <0>GIPHY</0>. G-rated (suitable for viewing by all ages), tracking parameters are stripped, referrer information is omitted from requests, but search queries and IP address information will still reach their servers."
msgstr "Pastaba: ši funkcija naudoja išorinę GIF paieškos paslaugą, veikiančią su <0>„GIPHY“</0>. „G-rated“ (skirta visiems amžiaus grupėms), sekimo parametrai pašalinami, užklausose nepateikiama nukreipiančioji informacija, bet paieškos užklausos ir IP adreso informacija vis tiek pasieks jų serverius."

#: src/pages/settings.jsx:570
msgid "Image description generator"
msgstr "Vaizdų aprašymo generatorius"

#: src/pages/settings.jsx:575
msgid "Only for new images while composing new posts."
msgstr "Tik naujiems vaizdams, kai kuriami nauji įrašai."

#: src/pages/settings.jsx:582
msgid "Note: This feature uses external AI service, powered by <0>img-alt-api</0>. May not work well. Only for images and in English."
msgstr "Pastaba: ši funkcija naudoja išorinę DI paslaugą, veikiančią su <0>„img-alt-api“</0>. Gali veikti netinkamai. Tik vaizdams ir anglų kalba."

#: src/pages/settings.jsx:608
msgid "Server-side grouped notifications"
msgstr "Serverio pusėje sugrupuoti pranešimai"

#: src/pages/settings.jsx:612
msgid "Alpha-stage feature. Potentially improved grouping window but basic grouping logic."
msgstr "Alfa stadijos funkcija. Galimai patobulintas grupavimo langas, bet bazinė grupavimo logika."

#: src/pages/settings.jsx:633
msgid "\"Cloud\" import/export for shortcuts settings"
msgstr "„Debesis“ importuoti / eksportuoti trumpųjų nuorodų nustatymus"

#: src/pages/settings.jsx:638
msgid "⚠️⚠️⚠️ Very experimental.<0/>Stored in your own profile’s notes. Profile (private) notes are mainly used for other profiles, and hidden for own profile."
msgstr "⚠️⚠️⚠️ Labai eksperimentinis.<0/>Įrašyta jūsų profilio pastabose. Profilio (privačios) pastabos daugiausia naudojamos kitiems profiliams, o savo profilyje yra paslėptos."

#: src/pages/settings.jsx:649
msgid "Note: This feature uses currently-logged-in instance server API."
msgstr "Pastaba: ši funkcija naudoja šiuo metu prisijungusio serverio API."

#: src/pages/settings.jsx:666
msgid "Cloak mode <0>(<1>Text</1> → <2>████</2>)</0>"
msgstr "Slėpimo režimas <0>(<1>Tekstas</1> → <2>███████</2>)</0>"

#: src/pages/settings.jsx:675
msgid "Replace text as blocks, useful when taking screenshots, for privacy reasons."
msgstr "Pakeiskite tekstą blokais – tai naudinga darant ekrano kopijas dėl privatumo priežasčių."

#: src/pages/settings.jsx:700
msgid "About"
msgstr "Apie"

#: src/pages/settings.jsx:739
msgid "<0>Built</0> by <1>@cheeaun</1>"
msgstr "<0>Sukūrė</0> <1>@cheeaun</1>"

#: src/pages/settings.jsx:768
msgid "Sponsor"
msgstr "Remti"

#: src/pages/settings.jsx:776
msgid "Donate"
msgstr "Aukoti"

#: src/pages/settings.jsx:792
msgid "Privacy Policy"
msgstr "Privatumo politika"

#: src/pages/settings.jsx:799
msgid "<0>Site:</0> {0}"
msgstr "<0>Svetainė:</0> {0}"

#: src/pages/settings.jsx:806
msgid "<0>Version:</0> <1/> {0}"
msgstr "<0>Versija:</0> <1/> {0}"

#: src/pages/settings.jsx:821
msgid "Version string copied"
msgstr "Nukopijuota versijos eilutė"

#: src/pages/settings.jsx:824
msgid "Unable to copy version string"
msgstr "Nepavyksta nukopijuoti versijos eilutės."

#: src/pages/settings.jsx:1058
#: src/pages/settings.jsx:1063
msgid "Failed to update subscription. Please try again."
msgstr "Nepavyko atnaujinti prenumeratos. Bandykite dar kartą."

#: src/pages/settings.jsx:1069
msgid "Failed to remove subscription. Please try again."
msgstr "Nepavyko pašalinti prenumeratos. Bandykite dar kartą."

#: src/pages/settings.jsx:1076
msgid "Push Notifications (beta)"
msgstr "Tiesioginiai pranešimai (beta versija)"

#: src/pages/settings.jsx:1098
msgid "Push notifications are blocked. Please enable them in your browser settings."
msgstr "Tiesioginiai pranešimai yra užblokuoti. Įjunkite juos naršyklės nustatymuose."

#: src/pages/settings.jsx:1107
msgid "Allow from <0>{0}</0>"
msgstr "Leisti iš <0>{0}</0>"

#: src/pages/settings.jsx:1116
msgid "anyone"
msgstr "bet kieno"

#: src/pages/settings.jsx:1120
msgid "people I follow"
msgstr "žmonių, kuriuos seku"

#: src/pages/settings.jsx:1124
msgid "followers"
msgstr "sekėjų"

#: src/pages/settings.jsx:1157
msgid "Follows"
msgstr "Sekimai"

#: src/pages/settings.jsx:1165
msgid "Polls"
msgstr "Apklausos"

#: src/pages/settings.jsx:1169
msgid "Post edits"
msgstr "Įrašų redagavimai"

#: src/pages/settings.jsx:1190
msgid "Push permission was not granted since your last login. You'll need to <0><1>log in</1> again to grant push permission</0>."
msgstr "Nuo paskutinio prisijungimo nebuvo suteiktas tiesioginis leidimas. Turėsite <0><1>prisijungti</1> dar kartą, kad suteiktumėte tiesioginį leidimą</0>."

#: src/pages/settings.jsx:1206
msgid "NOTE: Push notifications only work for <0>one account</0>."
msgstr "Pastaba: tiesioginiai pranešimai veikia tik <0>vienai paskyrai</0>."

#. js-lingui-explicit-id
#: src/pages/status.jsx:597
#: src/pages/status.jsx:1131
msgid "post.title"
msgstr "Įrašas"

#: src/pages/status.jsx:822
msgid "You're not logged in. Interactions (reply, boost, etc) are not possible."
msgstr "Nesate prisijungę. Sąveikos (atsakyti, pasidalinti ir t. t.) negalimos."

#: src/pages/status.jsx:842
msgid "This post is from another instance (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."
msgstr "Šis įrašas yra iš kito serverio (<0>{instance}</0>). Sąveikos (atsakyti, pasidalinti ir t. t.) negalimos."

#: src/pages/status.jsx:870
msgid "Error: {e}"
msgstr "Klaida: {e}"

#: src/pages/status.jsx:877
msgid "Switch to my instance to enable interactions"
msgstr "Perjungti į mano serverį, kad būtų įjungtos sąveikos"

#: src/pages/status.jsx:979
msgid "Unable to load replies."
msgstr "Nepavyksta įkelti atsakymų."

#: src/pages/status.jsx:1091
msgid "Back"
msgstr "Atgal"

#: src/pages/status.jsx:1122
msgid "Go to main post"
msgstr "Eiti į pagrindinį įrašą"

#: src/pages/status.jsx:1145
msgid "{0} posts above ‒ Go to top"
msgstr "{0} įrašų aukščiau – eiti į viršų"

#: src/pages/status.jsx:1188
#: src/pages/status.jsx:1251
msgid "Switch to Side Peek view"
msgstr "Perjungti į šoninio žvilgsnio rodymą"

#: src/pages/status.jsx:1252
msgid "Switch to Full view"
msgstr "Perjungti į visą rodymą"

#: src/pages/status.jsx:1270
msgid "Show all sensitive content"
msgstr "Rodyti visą jautrų turinį"

#: src/pages/status.jsx:1275
msgid "Experimental"
msgstr "Eksperimentinis"

#: src/pages/status.jsx:1284
msgid "Unable to switch"
msgstr "Nepavyksta perjungti."

#: src/pages/status.jsx:1291
msgid "Switch to post's instance ({0})"
msgstr "Perjungti į įrašo serverį ({0})"

#: src/pages/status.jsx:1294
msgid "Switch to post's instance"
msgstr "Perjungti į įrašo serverį"

#: src/pages/status.jsx:1352
msgid "Unable to load post"
msgstr "Nepavyksta įkelti įrašo."

#: src/pages/status.jsx:1487
msgid "{0, plural, one {# reply} other {<0>{1}</0> replies}}"
msgstr "{0, plural, one {# atsakymas} few {<0>{1}</0> atsakymai} many {<0>{1}</0> atsakymo} other {<0>{1}</0> atsakymų}}"

#: src/pages/status.jsx:1505
msgid "{totalComments, plural, one {# comment} other {<0>{0}</0> comments}}"
msgstr "{totalComments, plural, one {# komentaras} few {<0>{0}</0> komentarai} many {<0>{0}</0> komentaro} other {<0>{0}</0> komentarų}}"

#: src/pages/status.jsx:1527
msgid "View post with its replies"
msgstr "Peržiūrėti įrašą su jo atsakymais"

#: src/pages/trending.jsx:71
msgid "Trending ({instance})"
msgstr "Tendencinga ({instance})"

#: src/pages/trending.jsx:228
msgid "Trending News"
msgstr "Tendencingos naujienos"

#. By [Author]
#: src/pages/trending.jsx:347
msgid "By {0}"
msgstr "Sukūrė {0}"

#: src/pages/trending.jsx:408
msgid "Back to showing trending posts"
msgstr "Atgal į tendencingų įrašų rodymą"

#: src/pages/trending.jsx:413
msgid "Showing posts mentioning <0>{0}</0>"
msgstr "Rodomi įrašai, kuriuose paminimas <0>{0}</0>"

#: src/pages/trending.jsx:425
msgid "Trending posts"
msgstr "Tendencingi įrašai"

#: src/pages/trending.jsx:448
msgid "No trending posts."
msgstr "Nėra tendencingų įrašų."

#: src/pages/welcome.jsx:53
msgid "A minimalistic opinionated Mastodon web client."
msgstr "Minimalistinė „Mastodon“ interneto kliento programa."

#: src/pages/welcome.jsx:64
msgid "Log in with Mastodon"
msgstr "Prisijungti su „Mastodon“"

#: src/pages/welcome.jsx:70
msgid "Sign up"
msgstr "Registruotis"

#: src/pages/welcome.jsx:77
msgid "Connect your existing Mastodon/Fediverse account.<0/>Your credentials are not stored on this server."
msgstr "Prijunkite esamą „Mastodon“ / fediverso paskyrą.<0/>Jūsų kredencialai šiame serveryje nėra saugomi."

#: src/pages/welcome.jsx:94
msgid "<0>Built</0> by <1>@cheeaun</1>. <2>Privacy Policy</2>."
msgstr "<0>Sukūrė</0> <1>@cheeaun</1>. <2>Privatumo politika</2>."

#: src/pages/welcome.jsx:125
msgid "Screenshot of Boosts Carousel"
msgstr "Pasidalinimų karuselės ekrano kopija"

#: src/pages/welcome.jsx:129
msgid "Boosts Carousel"
msgstr "Pasidalinimų karuselė"

#: src/pages/welcome.jsx:132
msgid "Visually separate original posts and re-shared posts (boosted posts)."
msgstr "Vizualiai atskirkite originalius įrašus ir pakartotinai bendrinamus įrašus (pasidalintus įrašus)."

#: src/pages/welcome.jsx:141
msgid "Screenshot of nested comments thread"
msgstr "Įterptų komentarų gijos ekrano kopija"

#: src/pages/welcome.jsx:145
msgid "Nested comments thread"
msgstr "Įterptų komentarų gija"

#: src/pages/welcome.jsx:148
msgid "Effortlessly follow conversations. Semi-collapsible replies."
msgstr "Lengvai sekite pokalbius. Pusiau suskleidžiamieji atsakymai."

#: src/pages/welcome.jsx:156
msgid "Screenshot of grouped notifications"
msgstr "Sugrupuotų pranešimų ekrano kopija"

#: src/pages/welcome.jsx:160
msgid "Grouped notifications"
msgstr "Sugrupuoti pranešimai"

#: src/pages/welcome.jsx:163
msgid "Similar notifications are grouped and collapsed to reduce clutter."
msgstr "Panašūs pranešimai sugrupuojami ir suskleidžiami, kad būtų mažiau netvarkos."

#: src/pages/welcome.jsx:172
msgid "Screenshot of multi-column UI"
msgstr "Daugiastulpelių naudotojo sąsajos ekrano kopija"

#: src/pages/welcome.jsx:176
msgid "Single or multi-column"
msgstr "Vieno arba daugiastulpelių"

#: src/pages/welcome.jsx:179
msgid "By default, single column for zen-mode seekers. Configurable multi-column for power users."
msgstr "Pagal numatytuosius nustatymus – vienas stulpelis zeno režimo ieškikliams. Galimybė konfigūruoti daugiastulpelius patyrusiems naudotojams."

#: src/pages/welcome.jsx:188
msgid "Screenshot of multi-hashtag timeline with a form to add more hashtags"
msgstr "Daugiasaitažodžių laiko skalės ekrano kopija su forma, kuria galima pridėti daugiau saitažodžių"

#: src/pages/welcome.jsx:192
msgid "Multi-hashtag timeline"
msgstr "Daugiasaitažodžių laiko skalė"

#: src/pages/welcome.jsx:195
msgid "Up to 5 hashtags combined into a single timeline."
msgstr "Iki 5 saitažodžių, sujungtų į vieną laiko skalę."

#: src/utils/open-compose.js:24
msgid "Looks like your browser is blocking popups."
msgstr "Atrodo, kad jūsų naršyklė blokuoja iškylančiuosius langus."

#: src/utils/show-compose.js:16
msgid "A draft post is currently minimized. Post or discard it before creating a new one."
msgstr "Įrašo juodraštis šiuo metu sumažintas. Paskelbkite arba atmeskite jį prieš sukuriant naują."

#: src/utils/show-compose.js:21
msgid "A post is currently open. Post or discard it before creating a new one."
msgstr "Įrašas šiuo metu atidarytas. Paskelbkite arba atmeskite jį prieš sukuriant naują."

